<template>
  <div class="version-list-page">
    <v-tabs id="release_experiences" v-model="tab" show-arrows center-active color="primary">
      <v-tab v-for="(item, index) in tab_items" :key="item.title" :value="index" :href="`#${item.key}`">
        {{ item.title }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-if="isLoading === false" v-model="tab" color="blue darken-4">
      <v-container v-if="tab == 'detail' && memberQuota && memberQuota[$route.params.org_id]" style="max-width: 100%">
        <UsedQuotaInfo
          v-if="isLoading === false"
          :service="`變化版本數`"
          :usage="items.length"
          :limit="getQuota"
          :is_show_percentbar="true"
        />
        <v-row
          v-if="
            (experiment.enable === true && experiment.release) || (experiment.enable === false && experiment.release)
          "
          class="pb-0 mb-3"
        >
          <v-col cols="12" class="pb-0">
            <v-card
              class="mt-0 pt-2 pb-0 pl-0"
              :class="{
                release:
                  experiment.enable &&
                  experiment.release &&
                  new Date().getTime() < new Date(experiment.end_at).getTime(),
                end:
                  experiment.enable === false ||
                  (experiment.enable &&
                    experiment.release &&
                    new Date().getTime() > new Date(experiment.end_at).getTime()),
              }"
            >
              <v-card-title class="pl-3 pt-0 pb-2 text-subtile2 white--text">
                <template
                  v-if="
                    experiment.release === true &&
                    experiment.enable === true &&
                    new Date().getTime() < new Date(experiment.end_at).getTime()
                  "
                >
                  <div>
                    <v-icon color="white" class="mr-3"> mdi-timer-outline </v-icon>
                    <span>執行中</span>
                  </div>
                </template>

                <template v-else>
                  <div>
                    <v-icon color="white" class="mr-3"> mdi-check-circle-outline </v-icon>
                    <span>已結束</span>
                  </div>
                </template>

                <v-spacer></v-spacer>

                <template
                  v-if="
                    experiment.release === true &&
                    experiment.enable === true &&
                    new Date().getTime() < new Date(experiment.end_at).getTime()
                  "
                >
                  <v-btn class="release--text" color="white" @click="stopExperiment">
                    <v-icon left color="release"> mdi-stop-circle-outline </v-icon>
                    結束實驗
                  </v-btn>
                </template>
              </v-card-title>
              <v-card-text
                class="pt-1 pb-1 pl-4 pr-0 text-subtitle-1 d-flex white--text"
                :class="{
                  'green darken-2': experiment.enable && experiment.release,
                  'grey darken-2':
                    experiment.enable === false ||
                    (experiment.enable &&
                      experiment.release &&
                      new Date().getTime() > new Date(experiment.end_at).getTime()),
                }"
              >
                <v-row>
                  <v-col cols="12" xs="12" md="6" lg="6">
                    <p class="pb-0 mb-0">{{ `開始: ${$utils.timeFormatMonitor(experiment.start_at)}` }}</p>
                  </v-col>
                  <v-col cols="12" xs="12" md="6" lg="6">
                    <p class="pb-0 mb-0">
                      {{ `結束: ${$utils.timeFormatMonitor(experiment.end_at)}` }}

                      <span v-if="new Date(experiment.start_at).getTime() > new Date(experiment.end_at).getTime()">
                        (在開始前被手動終止)
                      </span>
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-card
          v-if="is_end === '' && is_release === ''"
          style="margin-bottom: 20px"
          class="d-flex flex-column justify-space-between align-center"
        >
          <v-card-text class="d-flex flex-row align-center justify-space-between pa-0 draft">
            <v-card-subtitle class="white--text d-flex">
              <v-icon left class="white--text">
                {{ mdi_icon }}
              </v-icon>
              <div>
                <div>{{ is_release !== '' || is_end !== '' ? is_release || is_end : is_draft }}</div>
              </div>
            </v-card-subtitle>
            <!--            <div>-->
            <!--              <v-btn class="mr-2" @click="openUpdateExperientsDialog">-->
            <!--                <v-icon left> mdi-pencil </v-icon>-->
            <!--                編輯實驗-->
            <!--              </v-btn>-->
            <!--- :disabled=" !is_check ? true : false "這段意思是如果is_check是false，代表有東西沒填完就要給他true禁止點選--->
            <v-btn
              class="mr-2 draft--text"
              color="white"
              :disabled="!is_check ? true : false"
              @click="releaseExperience()"
            >
              <v-icon left> mdi-play-circle-outline </v-icon>
              發布實驗
            </v-btn>
            <!--            </div>-->
          </v-card-text>
          <v-card-text class="d-flex flex-row align-center justify-space-between pt-3 pb-3 orange darken-2">
            <v-row>
              <v-col cols="12" xs="12" md="6" lg="6">
                <p class="pb-0 mb-0 white--text">{{ `開始: ${$utils.timeFormatMonitor(experiment.start_at)}` }}</p>
              </v-col>
              <v-col cols="12" xs="12" md="6" \lg="6">
                <p class="pb-0 mb-0 white--text">{{ `結束: ${$utils.timeFormatMonitor(experiment.end_at)}` }}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-stepper id="goal" non-linear value="1" style="margin-bottom: 20px" color="primary">
          <v-stepper-header>
            <v-stepper-step
              v-scroll-to="'#goal'"
              step="1"
              color="primary"
              style="cursor: pointer"
              :editable="isEditableStep1"
              :complete="isCompleteStep1"
            >
              建立子類
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              v-scroll-to="'#target'"
              step="2"
              color="primary"
              :editable="isEditableStep2"
              :complete="isCompleteStep2"
              style="cursor: pointer"
            >
              新增指定目標規則
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              step="3"
              color="primary"
              :editable="isEditableStep3"
              :complete="isCompleteStep3"
              style="cursor: pointer"
              @click="$utils.scroll_to('codeInstall')"
            >
              代碼安裝狀態
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              v-scroll-to="'#release_experiences'"
              step="4"
              color="primary"
              :editable="isEditableStep4"
              :complete="isCompleteStep4"
              style="cursor: pointer"
            >
              開始
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
        <v-card>
          <v-card-title class="text_primary">
            <v-icon left class="text_primary"> mdi-ab-testing </v-icon>
            {{ page_title }}

            <v-spacer></v-spacer>

            <v-btn
              class="mr-2 white--text"
              color="#5087e6"
              :disabled="is_already || is_inactivate"
              @click="open_dialog('新增版本')"
            >
              <v-icon left> mdi-plus-circle </v-icon>
              新增版本
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12" class="d-flex flex-column flex-end" style="border-bottom: 1px solid #ddd">
                  <div>
                    <v-card-subtitle :style="{ color: 'black' }"> 變化版本 </v-card-subtitle>
                    <v-card-text v-model="validate_text">
                      {{ '您想進行什麼測試？' }}
                    </v-card-text>
                  </div>
                  <div>
                    <!-- {{view_loading}} -->
                    <v-data-table
                      :key="table_key"
                      :headers="headers"
                      :items="items"
                      hide-default-footer
                      sort-by="sort_key"
                      :loading="view_loading"
                      :loading-text="'載入中'"
                      :items-per-page="items.length"
                      :item-class="getRowClass"
                    >
                      <template #[`item.actions`]="{ item }">
                        <div class="d-flex justify-end">
                          <!-- 執行中 -->
                          <template
                            v-if="
                              experiment.release === true &&
                              experiment.enable === true &&
                              new Date().getTime() < new Date(experiment.end_at).getTime()
                            "
                          >
                            <v-btn
                              v-if="!item.is_original && item.is_can_edit === true"
                              class="mr-3"
                              @click="viewInfo(item)"
                            >
                              編輯
                            </v-btn>

                            <v-btn v-if="!item.is_original" class="mr-3 purple white--text" @click="copyVer(item)">
                              複製
                            </v-btn>
                            <v-btn
                              v-if="!item.is_original && item.is_can_edit === true"
                              :color="$vuetify.theme.themes['dark']['warning']"
                              class="white--text mr-3"
                              @click="deleteVersion(item)"
                            >
                              刪除
                            </v-btn>

                            <v-btn color="#5087e6" class="white--text" @click="preview(item)"> 查看 </v-btn>
                          </template>

                          <!-- 已結束 -->
                          <template
                            v-if="
                              experiment.release === true &&
                              experiment.enable === false &&
                              new Date().getTime() > new Date(experiment.end_at).getTime()
                            "
                          >
                            <v-btn color="#5087e6" class="white--text" @click="preview(item)"> 查看 </v-btn>
                          </template>

                          <!-- 草稿 -->
                          <template v-if="!is_already">
                            <v-btn v-if="!item.is_original" class="mr-3" :disabled="is_already" @click="viewInfo(item)">
                              編輯
                            </v-btn>

                            <v-btn
                              v-if="!item.is_original && item.is_can_copy === true"
                              class="mr-3 purple white--text"
                              @click="copyVer(item)"
                            >
                              複製
                            </v-btn>

                            <v-btn
                              v-if="!item.is_original"
                              :color="$vuetify.theme.themes['dark']['warning']"
                              class="white--text mr-3"
                              :disabled="is_already"
                              @click="deleteVersion(item)"
                            >
                              刪除
                            </v-btn>

                            <v-btn color="#5087e6" class="white--text" @click="preview(item)"> 查看 </v-btn>
                          </template>
                        </div>
                      </template>

                      <template #[`item.status`]="{ item }">
                        <template v-if="is_already">
                          <v-icon v-if="item.priority !== '0'" color="success"> mdi-play-circle-outline </v-icon>
                          <v-icon v-else color="warning"> mdi-pause-circle-outline </v-icon>
                        </template>
                      </template>

                      <template #[`item.notify`]="{ item }">
                        <template v-if="!item.is_original">
                          <v-icon
                            v-if="item.notify === 'has_unread'"
                            color="pink"
                            @click="showNotifys(item.vid, 'unread')"
                          >
                            mdi-bell-alert
                          </v-icon>
                          <v-icon
                            v-else-if="item.notify === 'all_read'"
                            color="grey"
                            @click="showNotifys(item.vid, 'read')"
                          >
                            mdi-clipboard-text-clock-outline
                          </v-icon>
                        </template>
                      </template>

                      <template #[`item.history`]="{ item }">
                        <v-icon v-if="item.history && item.history.length > 0" @click="showHistory(item)">
                          mdi-history
                        </v-icon>
                      </template>

                      <template #[`item.name`]="{ item, attrs }">
                        <div
                          class="d-flex align-center"
                          :class="{ 'item-clickable': item.name !== 'original' }"
                          @click="open_edit_views_name_dialog(item)"
                        >
                          <p v-bind="attrs" class="version_name ma-0">
                            {{ item.name === 'original' ? '原始版本' : item.name }}
                          </p>
                          <v-icon v-if="item.name !== 'original'" right small> mdi-pencil </v-icon>
                        </div>
                      </template>

                      <template #[`item.priority`]="{ item, attrs, on }">
                        <v-tooltip bottom>
                          <template #activator="{ on: tooltipOn }">
                            <v-btn
                              :style="{
                                color: 'rgb(26,115,232)',
                                backgroundColor: '#fff',
                                borderRadius: '3px',
                                boxShadow: 'none',
                              }"
                              v-bind="attrs"
                              class="priority_btn"
                              :disabled="
                                experiment.release === true &&
                                experiment.enable === false &&
                                new Date().getTime() > new Date(experiment.end_at).getTime()
                              "
                              @click="open_edit_priority_dialog(item)"
                              v-on="{ ...on, ...tooltipOn }"
                            >
                              <v-icon left> mdi-chart-donut </v-icon>
                              {{ `${item.priority}% 權重` }}
                            </v-btn>
                          </template>
                          <span>編輯版本權重</span>
                        </v-tooltip>
                      </template>

                      <template #[`item.memo`]="{ item, attrs, on }">
                        <v-tooltip bottom>
                          <template #activator="{ on: tooltipOn }">
                            <v-btn
                              :style="{
                                color: 'rgb(26,115,232)',
                                backgroundColor: '#fff',
                                borderRadius: '3px',
                                boxShadow: 'none',
                              }"
                              v-bind="attrs"
                              class="priority_btn"
                              :disabled="item.is_original"
                              @click="open_edit_views_memo_dialog(item)"
                              v-on="{ ...on, ...tooltipOn }"
                            >
                              <div class="memo-field mb-0">
                                {{ item.memo === '' ? '尚無任何說明' : item.memo }}
                              </div>
                            </v-btn>
                          </template>
                          <span>編輯版本說明</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </div>

                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        id="target"
                        class="d-flex justify-end truncate"
                        :style="{
                          color: 'rgba(0, 0, 0, 0.4)',
                          backgroundColor: '#fff',
                          borderRadius: '3px',
                          boxShadow: 'none',
                          textTransform: 'lowercase',
                        }"
                        :disabled="is_already"
                        v-on="on"
                        @click="open_update_url_dialog"
                      >
                        <div id="truncate">
                          {{ `編輯器頁面 : ${experiment.url}` }}
                        </div>
                        <v-icon right style="font-size: 18px"> mdi-pencil </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ `${experiment.url}` }}</span>
                  </v-tooltip>
                </v-col>

                <v-col cols="12" class="d-flex flex-column">
                  <div class="d-flex align-center justify-space-between">
                    <div>
                      <v-card-subtitle :style="{ color: 'black' }"> 指定網頁 </v-card-subtitle>
                      <v-card-text v-model="validate_text">
                        {{ '要在網站上的哪個位置執行這個實驗？' }}
                      </v-card-text>
                    </div>
                  </div>

                  <v-row v-if="rule_items.length > 0">
                    <v-col cols="12" md="7">
                      <v-text-field
                        v-model="check_url"
                        outlined
                        validate-on-blur
                        hide-details="auto"
                        placeholder="輸入網址檢查"
                        color="primary"
                        :rules="[rules.validateUrl]"
                        @blur="handleCheckUrl(check_url)"
                      >
                        filter_status_close
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="auto" align-self="center">
                      <v-btn
                        class="white--text"
                        color="#5087e6"
                        :disabled="checkInputValueIsValidate"
                        @click="checkWebRule"
                      >
                        <v-icon left> mdi-code-tags-check </v-icon>
                        檢查網址規則
                      </v-btn>
                    </v-col>
                    <v-col cols="12" sm="auto" align-self="center">
                      <v-btn class="white--text" color="#5087e6" @click="checkSameRuleUrlSwitch(true)">
                        查看符合規則的網址
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-card-title v-if="check_rule_chip_items.length > 0 && rule_items.length > 0">
                    當前檢查網址：
                  </v-card-title>
                  <v-chip-group
                    v-if="check_rule_chip_items.length > 0 && rule_items.length > 0"
                    column
                    active-class="primary--text"
                    style="margin-left: 20px; width: 100%"
                  >
                    <v-chip
                      v-for="(chip, index) in check_rule_chip_items"
                      :key="chip.id"
                      close
                      close-icon="mdi-close"
                      class="white--text"
                      style="height: 100%"
                      color="primary"
                      @click:close="removeChip(index)"
                    >
                      {{ `檢查網址：${chip} ` }}
                    </v-chip>
                  </v-chip-group>

                  <div>
                    <v-card v-if="rule_items.length < 1" style="background-color: rgba(26, 115, 232, 0.05)">
                      <v-container fluid>
                        <v-row class="d-flex justify-space-between align-center">
                          <v-col>
                            <v-card-text>
                              <v-icon color="warning" left> mdi-alert </v-icon>
                              必須提供至少一個網址規則
                            </v-card-text>
                          </v-col>

                          <v-btn
                            color="primary"
                            style="color: #fff; margin-right: 20px"
                            :disabled="is_already"
                            @click="open_url_rule_dialog"
                          >
                            {{ `新增網址規則` }}
                          </v-btn>
                        </v-row>
                      </v-container>
                    </v-card>

                    <!--- 網頁規則table ---->
                    <v-card v-if="rule_items.length > 0" style="margin-top: 20px">
                      <ExperimentListWebRule
                        :experiment="experiment"
                        :rule-items="rule_items"
                        @updateExperienceRule="open_update_url_rule_dialog"
                        @deleteExperienceRule="deleteExperienceRule"
                        @createExperienceRule="open_url_rule_dialog"
                      />

                      <div
                        v-if="$auth_helper.isShowFeature($store, $route.params.org_id, 'ExperienceRemoveHashTag')"
                        class="mt-4 ml-4 pb-4"
                      >
                        <v-checkbox
                          v-model="remove_hash_tag"
                          :label="`隱藏網址片段(hashtag)`"
                          :hint="'。'"
                          hide-details
                          :disabled="is_already"
                          @click="updateReplaceHashTag(remove_hash_tag)"
                        ></v-checkbox>
                        <p class="mt-1">啟用後，當載入實驗，自動將網址的網址片段移除</p>
                      </div>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <!-- 權重排程區塊 -->
          <v-card
            v-if="
              (isRelease || (isEnd && view_schedule_list.length)) &&
              $auth_helper.isShowFeature($store, $route.params.org_id, 'ExperiencePrioritySchedule')
            "
          >
            <v-card-title class="d-flex justify-space-between align-center">
              <v-card-subtitle class="black--text">版本權重排程</v-card-subtitle>
              <v-btn
                class="mr-2"
                color="primary"
                :disabled="!experiment.release || new Date(experiment.end_at) < Date.now()"
                @click="viewScheduleDialogSwitch('create_view_schedule_dialog')"
              >
                <v-icon left>mdi-plus-circle</v-icon>
                新增權重排程
              </v-btn>
            </v-card-title>

            <v-divider />

            <v-card-text>
              <v-timeline align-top dense>
                <div v-for="(view_schedule_item, index) in view_schedule_list" :key="index">
                  <v-timeline-item small :color="viewScheduleStatusStyle(index).color">
                    <v-card :color="viewScheduleStatusStyle(index).color">
                      <v-card-title class="white--text py-2 px-1">
                        <v-row no-gutters>
                          <v-col cols="1" order="1">
                            <v-btn
                              v-if="viewScheduleStatusStyle(index).status === '未啟用'"
                              icon
                              @click="viewScheduleDialogSwitch('delete_view_schedule_dialog', view_schedule_item)"
                            >
                              <v-icon color="white">mdi-trash-can</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col order="2" offset="1" offset-md="0">
                            {{
                              `${$utils.timeFormatMonitor(view_schedule_item.start_at)} (${
                                viewScheduleStatusStyle(index).status
                              })`
                            }}
                          </v-col>
                          <v-col
                            cols="12"
                            md="5"
                            offset="1"
                            offset-md="0"
                            order="4"
                            order-md="3"
                            class="rounded-sm"
                            style="position: relative"
                          >
                            <v-btn
                              class="primary--text"
                              @click="descriptionEditDialogSwitch(view_schedule_item, index)"
                              v-text="view_schedule_item.memo.description || '尚無任何說明'"
                            />
                            <v-slide-x-transition>
                              <v-card
                                v-show="view_schedule_item.edit_description_switch"
                                :id="`edit_description_${index}`"
                                class="edit-description-card"
                                tabindex="0"
                                @blur="(e) => editDescriptionBlur(e, view_schedule_item, index)"
                              >
                                <v-card-title class="primary--text text-h6 py-3" v-text="'編輯'" />
                                <v-card-text class="py-0">
                                  <v-text-field
                                    v-model="view_schedule_item.curr_description"
                                    autofocus
                                    dense
                                    :rules="[inputRules().textLength]"
                                    @input="viewScheduleItemExpandSwitch(view_schedule_item, 'open')"
                                    @blur="(e) => editDescriptionBlur(e, view_schedule_item, index)"
                                    @keydown.enter="
                                      saveCurrDescriptionValue(view_schedule_item, view_schedule_item.curr_description)
                                    "
                                  />
                                </v-card-text>
                                <v-card-actions class="justify-end pt-0">
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="
                                      view_schedule_item.edit_description_switch = false
                                      view_schedule_item.curr_description = ''
                                    "
                                    v-text="'取消'"
                                  />
                                  <v-btn
                                    text
                                    type="submit"
                                    color="primary"
                                    @click="
                                      saveCurrDescriptionValue(view_schedule_item, view_schedule_item.curr_description)
                                    "
                                    v-text="'修改'"
                                  />
                                </v-card-actions>
                              </v-card>
                            </v-slide-x-transition>
                          </v-col>
                          <v-col cols="1" order="3" order-md="4" class="d-flex justify-end">
                            <v-btn icon @click="viewScheduleItemExpandSwitch(view_schedule_item)">
                              <v-icon color="white">{{
                                view_schedule_item.expand_switch ? 'mdi-chevron-up' : 'mdi-chevron-down'
                              }}</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-title>

                      <v-expand-transition>
                        <div v-show="view_schedule_item.expand_switch">
                          <v-card-text class="white pb-0">
                            <v-data-table
                              class="px-4"
                              hide-default-footer
                              :headers="view_schedule_headers"
                              :items="changeDataFormatToTable(view_schedule_item.setting)"
                              :items-per-page="changeDataFormatToTable(view_schedule_item.setting).length"
                            >
                              <template #item.name="{ item }">
                                {{ view_schedule_version_name[item.name] }}
                              </template>

                              <template #item.priority="{ item }">
                                <v-btn
                                  v-if="viewScheduleStatusStyle(index).status !== '未啟用'"
                                  text
                                  color="primary"
                                  disabled
                                >
                                  <v-icon left>mdi-chart-donut</v-icon>
                                  {{ `${item.priority}% 權重` }}
                                </v-btn>
                                <v-edit-dialog
                                  v-else
                                  large
                                  cancel-text="取消"
                                  save-text="修改"
                                  :return-value.sync="item.curr_priority"
                                  @save="saveCurrPriorityValue(view_schedule_item, item)"
                                  @open="$set(item, 'curr_priority', item.priority)"
                                >
                                  <v-btn text color="primary">
                                    <v-icon left>mdi-chart-donut</v-icon>
                                    {{ `${item.priority}% 權重` }}
                                  </v-btn>

                                  <template #input>
                                    <p class="text-h6 my-3 primary--text" v-text="'編輯'" />
                                    <v-text-field
                                      v-model="item.curr_priority"
                                      dense
                                      single-line
                                      counter
                                      hide-spin-buttons
                                      type="number"
                                      label="更新權重"
                                    />
                                  </template>
                                </v-edit-dialog>
                              </template>
                            </v-data-table>
                          </v-card-text>
                          <v-card-actions
                            v-if="viewScheduleStatusStyle(index).status === '未啟用'"
                            class="justify-end white"
                          >
                            <v-btn text @click="resetUpdateViewScheduleItem(view_schedule_item)">復原</v-btn>
                            <v-btn color="primary" @click="updateViewSchedule(view_schedule_item)">保存</v-btn>
                          </v-card-actions>
                        </div>
                      </v-expand-transition>
                    </v-card>
                  </v-timeline-item>
                </div>
              </v-timeline>
            </v-card-text>
          </v-card>

          <v-divider></v-divider>

          <v-card-text v-if="$auth_helper.isShowFeature($store, $route.params.org_id, 'ExperienceDeviceControl')">
            <v-card-subtitle :style="{ color: 'black' }"> 實驗裝置限制 </v-card-subtitle>

            <div class="pl-4">
              <v-chip-group v-model="activate_devices" column multiple label @change="updateDevice(activate_devices)">
                <v-chip
                  v-for="(experience_device, idx) in experience_devices"
                  :key="idx"
                  active-class="primary--text"
                  filter
                  outlined
                  :disabled="is_already"
                >
                  {{ experience_device.text }}
                </v-chip>
              </v-chip-group>
            </div>
          </v-card-text>
        </v-card>

        <!--- 子組件 --->
        <Description id="evalute" :experiment="experiment" />

        <!-- <EvaluteAndGoals /> -->

        <Settings v-if="experiment_setting.is_show" :experiment="experiment_setting" />

        <DialogForm v-if="is_show_new_dialog" :dialog-setting="dialog_setting" @submit="submit" @close="close">
        </DialogForm>

        <!-- 檢查網頁規則彈窗 Start -->
        <DialogForm
          v-if="is_show_check_rule_dialog"
          :dialog-setting="check_rule_dialog_setting"
          @submit="checkWebRule"
          @close="close"
        />

        <!--- 編輯版本權重彈窗 --->
        <DialogForm
          v-if="is_open_edit_priority_dialog"
          :dialog-setting="dialog_setting"
          @apiPatchViewPriority="apiPatchViewPriority"
          @close_edit_priority_dialog="close_edit_priority_dialog"
        />

        <!--- 編輯版本名稱彈窗 --->
        <DialogForm
          v-if="is_open_edit_views_name_dialog"
          :dialog-setting="dialog_setting"
          @submit="updateView"
          @close="close_edit_views_dialog"
        />

        <!--- 編輯版本說明彈窗 --->
        <DialogForm
          v-if="is_open_edit_views_memo_dialog"
          :dialog-setting="dialog_setting"
          @submit="updateView"
          @close="close_edit_views_dialog"
        />

        <DialogForm
          v-if="is_open_url_rule_dialog"
          :dialog-setting="url_rule_dialog_setting"
          @close="close"
          @submit="createExperienceRule"
        >
          <template #help>
            <div class="d-flex justify-end">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-btn
                    :style="{
                      color: 'rgb(26,115,232)',
                      backgroundColor: '#fff',
                      borderRadius: '3px',
                      boxShadow: 'none',
                      padding: '0px !important',
                    }"
                    class="priority_btn"
                    v-bind="attrs"
                    @click="open_help_dialog = true"
                    v-on="on"
                  >
                    幫助
                    <v-icon right> mdi-help-circle-outline </v-icon>
                  </v-btn>
                </template>
                <span>{{ '點擊查看更多' }}</span>
              </v-tooltip>
            </div>
          </template>
        </DialogForm>

        <DialogForm
          v-if="is_open_update_url_rule_dialog"
          :dialog-setting="update_url_rule_dialog_setting"
          @close="close"
          @submit="updateExperienceRule"
          @updateDialogSetting="updateUrlRuleDialogSetting"
        >
          <template #help>
            <div class="d-flex justify-end">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-btn
                    :style="{
                      color: 'rgb(26,115,232)',
                      backgroundColor: '#fff',
                      borderRadius: '3px',
                      boxShadow: 'none',
                      padding: '0px !important',
                    }"
                    class="priority_btn"
                    v-bind="attrs"
                    @click="open_help_dialog = true"
                    v-on="on"
                  >
                    幫助
                    <v-icon right> mdi-help-circle-outline </v-icon>
                  </v-btn>
                </template>
                <span>{{ '點擊查看更多' }}</span>
              </v-tooltip>
            </div>
          </template>
        </DialogForm>

        <DialogForm v-if="is_open_target_object_dialog" :dialog-setting="target_object_dialog_setting" @close="close" />

        <DialogForm
          v-if="is_open_update_url_dialog"
          :dialog-setting="open_update_experience_url_dialog_setting"
          @submit="updateExperience"
          @close="close"
        />
      </v-container>

      <keep-alive>
        <v-container v-if="tab === 'report'" style="max-width: 100%">
          <Report :items="items" :selected-experience="experiment" />
        </v-container>
      </keep-alive>
    </v-tabs-items>

    <HelpDialog v-if="open_help_dialog" @close="open_help_dialog = false">
      <template #content>
        <v-row justify="center">
          <v-expansion-panels multiple>
            <v-expansion-panel v-for="item in url_pattern_descriiption" :key="item.id" :item="item">
              <v-expansion-panel-header>{{ item.name }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <span>{{ `說明： ${item.description}` }}</span>
                <br />
                <span>範例網址： </span>

                <!--- 通訊協定 --->
                <span :style="{ color: item.id === 'url' ? 'red' : '' }">
                  {{ `${protocol}//` }}
                </span>

                <!--- 主機 --->
                <span :style="{ color: item.id === 'url' || item.id === 'host' ? 'red' : '' }">
                  {{ hostname }}
                </span>

                <!--- 路徑 --->
                <span :style="{ color: item.id === 'url' || item.id === 'path' ? 'red' : '' }">
                  {{ pathname }}
                </span>

                <!--- 查詢字串 --->
                <span :style="{ color: item.id === 'url' ? 'red' : '' }">
                  {{ search }}
                </span>

                <!--- 網址片段 --->
                <span :style="{ color: item.id === 'url' ? 'red' : '' }"> # </span>
                <span :style="{ color: item.id === 'url' || item.id === 'url fragment' ? 'red' : '' }">
                  {{ hash }}
                </span>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </template>
      <template #actions>
        <v-row style="margin: 20px 10px 0px 0px; padding: 10px 0 0 0" class="d-flex justify-end">
          <v-btn color="primary" class="white--text" @click="open_help_dialog = false"> 關閉 </v-btn>
        </v-row>
      </template>
    </HelpDialog>

    <ExperienceModal
      v-if="is_open_update_dialog"
      :init_setting="experiment"
      :text_setting="text_setting"
      @close="is_open_update_dialog = false"
      @submit="updateExperienceV2"
    />

    <HistoryModal
      v-if="is_open_history"
      :headers="history_headers"
      :items="history_items"
      @close="is_open_history = false"
    />

    <v-dialog v-model="save_load_dialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pt-4">
          發布實驗中
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="delete_view_schedule_dialog"
      max-width="600"
      @click:outside="viewScheduleDialogSwitch('delete_view_schedule_dialog')"
    >
      <v-card>
        <v-card-title class="red white--text" v-text="'刪除排程'" />
        <v-card-text class="pt-4 pb-0 text-h6 black--text" v-text="'確定要刪除此排程嗎?'" />
        <v-card-actions class="justify-end">
          <v-btn @click="viewScheduleDialogSwitch('delete_view_schedule_dialog')" v-text="'取消'" />
          <v-btn class="ml-2 white--text" color="red" @click="deleteViewSchedule()" v-text="'確定'" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="create_view_schedule_dialog"
      max-width="600"
      @click:outside="viewScheduleDialogSwitch('create_view_schedule_dialog')"
    >
      <v-card>
        <v-card-title class="primary white--text" v-text="'新增權重排程'" />
        <v-card-text class="black--text pt-5 pb-0">
          <v-row no-gutters>
            <v-col cols="5">
              <label>
                開始時間：
                <span class="red--text text--accent-4 font-weight-medium">(必填)</span>
              </label>
              <date-picker
                v-model="curr_view_schedule_item.start_at"
                class="mt-2"
                type="datetime"
                format="YYYY-MM-DD HH:mm"
              />
            </v-col>
            <v-col cols="5" offset="2">
              <div class="d-flex align-center">
                <label v-text="'恢復到當前設定的時間：'" />
                <v-tooltip right max-width="200px" color="black">
                  <template #activator="{ on, attrs }">
                    <v-icon v-bind="attrs" color="black" v-on="on">mdi-help-circle-outline</v-icon>
                  </template>
                  <span>填寫此欄位將以當前權重設定幫您新增排程，以便於您恢復當前設定，若無上述需求則無須填寫。</span>
                </v-tooltip>
              </div>
              <date-picker
                v-model="curr_view_schedule_item.recover_at"
                class="mt-2"
                type="datetime"
                format="YYYY-MM-DD HH:mm"
              />
            </v-col>
            <v-col cols="12" class="mt-4">
              <label v-text="'說明：'" />
              <v-text-field
                v-model="curr_view_schedule_item.description"
                outlined
                dense
                class="mt-2"
                :rules="[inputRules().textLength]"
              />
            </v-col>
            <v-col cols="12">
              <v-data-table
                class="px-4"
                hide-default-footer
                :headers="view_schedule_headers"
                :items="changeDataFormatToTable(curr_view_schedule_item.setting)"
                :items-per-page="changeDataFormatToTable(curr_view_schedule_item.setting).length"
              >
                <template #item.name="{ item }">
                  {{ view_schedule_version_name[item.name] }}
                </template>

                <template #item.priority="{ item }">
                  <v-edit-dialog
                    large
                    cancel-text="取消"
                    save-text="修改"
                    :return-value.sync="item.curr_priority"
                    @save="saveCurrPriorityValue(curr_view_schedule_item, item)"
                    @open="$set(item, 'curr_priority', item.priority)"
                  >
                    <v-btn text color="primary">
                      <v-icon left>mdi-chart-donut</v-icon>
                      {{ `${item.priority}% 權重` }}
                    </v-btn>

                    <template #input>
                      <p class="text-h6 my-3 primary--text" v-text="'編輯'" />
                      <v-text-field
                        v-model="item.curr_priority"
                        dense
                        single-line
                        counter
                        hide-spin-buttons
                        type="number"
                        label="更新權重"
                      />
                    </template>
                  </v-edit-dialog>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn @click="viewScheduleDialogSwitch('create_view_schedule_dialog')" v-text="'取消'" />
          <v-btn class="ml-2 white--text" color="primary" @click="createViewSchedule()" v-text="'新增'" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="notify_dialog.is_show"
      v-model="notify_dialog.is_show"
      width="900"
      @click:outside="notify_dialog.is_show = false"
    >
      <v-card :key="notify_dialog.tab">
        <v-card-title class="text-h5 grey lighten-2">
          異常記錄
          <v-spacer></v-spacer>
          <v-btn icon @click="notify_dialog.is_show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-4">
          <v-tabs v-model="notify_dialog.tab" fixed-tabs background-color="white" class="full-tabs">
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#unread" @click="showNotifys(notify_dialog.vid, 'unread')">未處理</v-tab>
            <v-tab href="#read" @click="showNotifys(notify_dialog.vid, 'read')">已處理</v-tab>
          </v-tabs>
          <v-card>
            <v-data-table
              height="50vh"
              fixed-header
              :loading="notify_dialog.loading"
              :loading-text="notify_dialog.loading_text"
              :headers="notify_dialog.show_headers"
              :items="notify_dialog.items"
              :no-data-text="notify_dialog.no_data_text"
              hide-default-footer
              :items-per-page="notify_dialog.items.length"
              sort-by="timestamp"
              sort-desc
            >
              <template #[`item.push_status`]="{ item }">
                <template v-if="item.push_status === -1">
                  <div class="d-flex">
                    <v-icon small color="primay" class="mr-2"> mdi-information-outline </v-icon>
                    <span>通知失敗，請檢查Line綁定</span>
                  </div>
                </template>
                <template v-else-if="item.push_status === 1">
                  <div class="d-flex">
                    <v-icon small color="success" class="mr-2"> mdi-send-check-outline </v-icon>
                    <span>已通知</span>
                  </div>
                </template>
              </template>
              <template #[`item.url`]="{ item }">
                <div class="d-flex align-center justify-space-between">
                  <div class="row-pointer truncate-url">
                    <a target="_blank" @click="goView(item.url, notify_dialog.vid)">
                      {{ decodeURIComponent(decodeURIComponent(item.url)) }}
                    </a>
                  </div>

                  <v-icon
                    v-if="
                      $auth_helper.isShowFeature($store, $route.params.org_id, 'ExperienceRecording') &&
                      item.clarity_url
                    "
                    small
                    class="ml-3"
                    @click="$utils.openURL(item.clarity_url, '', true)"
                  >
                    mdi-video
                  </v-icon>

                  <v-icon small class="ml-3" @click="copyURL(item.url, notify_dialog.vid)"> mdi-content-copy </v-icon>
                </div>
              </template>
              <template #[`item.actions`]="{ item }">
                <div v-if="!item.read_at" class="d-flex justify-end">
                  <v-btn color="primary" @click="readNotify(item)"> 已處理 </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>

        <!-- <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                text
                @click="notify_dialog.is_show = false"
            >
                關閉
            </v-btn>
          </v-card-actions> -->
      </v-card>
    </v-dialog>

    <v-dialog v-model="check_same_rule_url_data.dialog" max-width="600">
      <v-card>
        <v-card-title class="primary white--text justify-space-between">
          符合規則的網址清單
          <v-btn text icon @click="checkSameRuleUrlSwitch(false)">
            <v-icon color="white" v-text="'mdi-close'" />
          </v-btn>
        </v-card-title>
        <v-sheet class="overflow-y-auto" max-height="400">
          <v-card-text class="px-4 pb-2 pt-5">
            <template v-if="check_same_rule_url_data.list.length">
              <v-row v-for="(item, index) in show_same_rule_url_list" :key="index" class="mt-3" no-gutters>
                <v-col>
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-chip
                        class="chip-style d-block text-center overflow-hidden"
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        @click="copy(item)"
                        v-text="item"
                      />
                    </template>
                    {{ item }}
                  </v-tooltip>
                </v-col>
                <v-col cols="2" class="d-flex justify-center">
                  <v-btn height="32" color="primary" @click="toPage(item)" v-text="'前往'" />
                </v-col>
              </v-row>
            </template>
            <v-sheet v-else class="d-flex align-center justify-center" height="100">
              <p class="text-body-1" v-text="'查無相關網址'" />
            </v-sheet>
          </v-card-text>
        </v-sheet>
        <v-card-actions class="justify-center">
          <v-pagination
            v-if="check_same_rule_url_data.list.length"
            v-model="check_same_rule_url_data.page"
            :length="check_same_rule_url_data.total_page"
            :total-visible="7"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <LoadingOverlay :is-loading="isLoading" />
  </div>
</template>

<script>
// import Vuex Helper
import { mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'

// import 子元件
import DialogForm from '@/components/Utils/DialogForm.vue'
import LoadingOverlay from '@/components/Utils/LoadingOverlay.vue'
import Description from './ChildComponent/Description.vue'
import Settings from './ChildComponent/Settings/Settings.vue'
import Report from '../Experiment/Report.vue'
import ExperimentListWebRule from './ChildComponent/ExperimentListWebRule.vue'
import HelpDialog from '@/components/Utils/HelpDialog.vue'
import UsedQuotaInfo from '@/components/Utils/UsedQuotaInfo.vue'
import ExperienceModal from './ChildComponent/ExperienceModal.vue'
import HistoryModal from './ChildComponent/HistoryModal.vue'

import {
  apiCreateView,
  apiGetExperience,
  apiDeleteView,
  apiPatchViewPriority,
  apiGetView,
  apiPatchExperienceRelease,
  apiPatchExperiment,
  apiPatchExperimentWithData,
  apiGetExperienceRule,
  apiCreateExperienceRule,
  apiUpdateExperienceRule,
  apiDeleteExperienceRule,
  apiPatchView,
  apiGetPreviewToken,
  apiPatchExperienceDisable,
  apiRenameVersion,
  apiCopyVersion,
  apiGetCopyView,
  apiReleaseVersion,
  apiGetViewSchedule,
  apiUpdateViewSchedule,
  apiDeleteViewSchedule,
  apiCreateViewSchedule,
  apiGetContainer,
  apiGetSameRuleUrlList,
} from '@/api/optimize.js'

import { apiGetSubscriptionInfoWithData, apiGetUserInfo } from '@/api/organize.js'

import { apiGetAnalysisReport } from '@/api/analysis.js'
import { apiGetContainerNotify, apiReadNotify } from '@/api/notify.js'

export default {
  name: 'VersionList',
  components: {
    DialogForm,
    LoadingOverlay,
    Description,
    Settings,
    Report,
    ExperimentListWebRule,
    HelpDialog,
    UsedQuotaInfo,
    ExperienceModal,
    HistoryModal,
    DatePicker,
  },
  provide() {
    return {
      parentMethod: this.copyToClipboard,
      snackbar: this.snackbar,
    }
  },
  data: function () {
    return {
      check_rule_chip_items: [],
      open_help_dialog: false,
      is_show_check_rule_dialog: false,
      url_pattern_descriiption: [
        {
          id: 'url',
          name: '何謂「完整網址」?',
          description: '完整網址包括主機、路徑、查詢字串、網址片段，如下範例網址紅色的字段。',
        },
        {
          id: 'host',
          name: '何謂「主機」?',
          description: '通訊協定(如:https://)至網址路徑之間的字，如下範例網址紅色的字段。',
        },
        {
          id: 'path',
          name: '何謂「路徑」?',
          description: '第一個斜線到問號前之間的文字，如下範例網址紅色的字段。',
        },
        {
          id: 'url fragment',
          name: '何謂「網址片段」?',
          description: '#字號後面的文字，如下範例網址紅色的字段。',
        },
      ],
      rule_items_headers: [
        { text: '條件', value: 'pattern', sortable: false },
        { text: '值', value: 'value', sortable: true },
        { text: '', value: 'actions', sortable: false },
      ],
      rule_items: [],
      is_open_update_dialog: false,
      tab: 0,
      tab_items: [
        {
          title: '詳情',
          value: 'Datail',
          key: 'detail',
        },
        {
          title: '報表',
          value: 'report',
          key: 'report',
        },
      ],
      is_open_target_object_dialog: false,
      is_open_url_rule_dialog: false,
      validate_text: '尚未驗證。開始體驗前，請確認「最佳化工具」 已正確安裝 (建議)。',
      isLoading: true,
      copyText: ``,

      script_dialog_background_color: '#fff',

      // 開啟安裝代碼彈窗
      isOpenAbtestScript: false,

      // 目標頁面:
      url: '',

      // 頁面名稱
      page_title: '指定目標和子類',

      experiment: null,

      // 裝每個版本的Array
      items: [],

      // handleData
      reportItems: [],

      breadcrumb_items: [
        {
          text: '容器列表',
          disabled: false,
          exact: true,
          to: '/:comtainer_id/containers',
        },
        {
          text: '實驗列表',
          disabled: false,
          exact: true,
          to: '',
        },
        {
          text: '版本列表',
          disabled: true,
          exact: true,
          to: '',
        },
      ],

      headers: [
        { text: '', value: 'notify', sortable: false },
        { text: '', value: 'status', sortable: false },
        { text: '版本名稱', value: 'name', sortable: false },
        { text: '權重(%)', value: 'priority', sortable: false },
        { text: '說明', value: 'memo', sortable: false },
        { text: '', value: 'actions', sortable: false },
        { text: '', value: 'history', sortable: false },
      ],
      is_open_history: false,
      history_headers: [
        { text: '行為', value: 'action', sortable: false },
        { text: '操作者', value: 'name', sortable: false },
        { text: '時間', value: 'time', sortable: false },
      ],
      history_items: [],

      btn: {
        view: '編輯',
        delete: '刪除',
        edit_priority: '自訂百分比',
      },

      is_show_new_dialog: false,

      dialog_setting: {
        title: '新增版本',
        fields: [
          {
            id: 'name',
            label: '版本名稱',
            hint: '例如: 改內文圖',
            type: 'text',
          },
        ],
        views: null,
        headers: null,
        submit_text: '完成',
        submit_callback: 'submit',
        close_callback: 'close',
      },

      url_rule_dialog_setting: {
        title: '新增網址規則',
        fields: [
          {
            id: 'mode',
            label: '',
            value: null,
            hint: 'Test Optimize',
            type: 'select',
            is_show: false,
            items: [
              '完整網址',
              // '主機',
              '路徑',
              '網址片段',
            ],
          },
          {
            id: 'pattern',
            label: '',
            value: null,
            hint: 'Test Optimize',
            type: 'select',
            is_show: false,
            items: [
              '包含',
              '不包含',
              // '符合',
              // '不符合',
              '等於',
              '不等於',
              // '開頭是',
              // '結尾是',
              // '開頭不是',
              // '結尾不是',
              // '與規則運算式相符',
              // '與規則運算式不符',
              // '與規則運算式相符(忽略大小寫)',
              // '與規則運算式不符(忽略大小寫)',
            ],
          },
          {
            id: 'values',
            label: '',
            hint: '',
            type: 'rule',
            value: null,
          },
          {
            id: '',
            label: '',
            hint: '',
            type: 'check_rule',
          },
        ],
        views: null,
        headers: null,
        submit_text: '新增',
        submit_callback: 'submit',
        close_callback: 'close',
      },
      update_url_rule_dialog_setting: {
        title: '更新網址規則',
        fields: [
          {
            id: 'mode',
            label: '',
            value: null,
            hint: 'Test Optimize',
            type: 'select',
            is_show: false,
            items: [
              '完整網址',
              // '主機',
              '路徑',
              '網址片段',
            ],
          },
          {
            id: 'pattern',
            label: '',
            value: null,
            hint: 'Test Optimize',
            type: 'select',
            is_show: false,
            items: [
              '包含',
              '不包含',
              // '符合',
              // '不符合',
              '等於',
              '不等於',
              // '開頭是',
              // '結尾是',
              // '開頭不是',
              // '結尾不是',
              // '與規則運算式相符',
              // '與規則運算式不符',
              // '與規則運算式相符(忽略大小寫)',
              // '與規則運算式不符(忽略大小寫)',
            ],
          },
          {
            id: 'values',
            label: '',
            hint: '',
            type: 'update_rule',
            value: [],
            newValue: null,
          },
          {
            id: '',
            label: '',
            hint: '',
            type: 'check_rule',
          },
        ],
        views: null,
        headers: null,
        submit_text: '儲存',
        submit_callback: 'submit',
        close_callback: 'close',
      },
      mapping_rule: {
        // 規則
        包含: 'in',
        不包含: 'nin',
        符合: 'mc',
        不符合: 'nmc',
        等於: 'eq',
        不等於: 'neq',
        開頭是: 'sw',
        結尾是: 'ew',
        開頭不是: 'nsw',
        結尾不是: 'new',
        與規則運算式相符: 'mr',
        與規則運算式不符: 'nmr',
        '與規則運算式相符(忽略大小寫)': 'ri',
        '與規則運算式不符(忽略大小寫)': 'nri',
        // 網址
        完整網址: 'url',
        主機: 'host',
        路徑: 'path',
        網址片段: 'urlFragment',
      },
      reverse_mapping_rule: {
        // 規則
        in: '包含',
        nin: '不包含',
        mc: '符合',
        nmc: '不符合',
        eq: '等於',
        neq: '不等於',
        sw: '開頭是',
        ew: '結尾是',
        nsw: '開頭不是',
        new: '結尾不是',
        mr: '與規則運算式相符',
        nmr: '與規則運算式不符',
        ri: '與規則運算式相符(忽略大小寫)',
        nri: '與規則運算式不符(忽略大小寫)',
        // 網址
        url: '完整網址',
        host: '主機',
        path: '路徑',
        urlFragment: '網址片段',
      },
      target_object_dialog_setting: {
        title: '選擇規則類型',
        fields: [
          {
            type: 'target_object',
            items: [{ category: 'Google Analytics (分析) 目標對象' }, { category: 'Google Ads' }],
          },
        ],
        views: null,
        headers: null,
        submit_text: '完成',
        submit_callback: 'submit',
        close_callback: 'close',
        type: 'target_object',
      },
      // 因為要並排顯示，多了grids這個key，在Dialogform.vue裡搜尋v-if="item.grids!==null"這裡會顯示更改時間的元件
      open_update_experience_dialog_setting: {
        title: '更新實驗',
        fields: [
          {
            id: 'name',
            label: '實驗名稱',
            value: null,
            hint: '家電產品A',
            type: 'text',
          },
          {
            id: 'url',
            label: '網址',
            value: null,
            hint: 'https://your_website.com/product',
            type: 'text',
          },
          {
            id: 'memo',
            label: '實驗說明',
            value: null,
            hint: '寫下對小組有幫助的說明。',
            type: 'text',
            is_show: false,
          },
          {
            type: null,
            is_show: false,
            label: '開始時間',
            grids: [
              {
                id: 'start_at',
                label: '開始時間',
                value: null,
                type: 'date',
                is_show: false,
                hint: '日期',
              },
              {
                id: 'start_at_time',
                label: '',
                value: null,
                type: 'time',
                is_show: false,
                hint: '時間',
              },
            ],
          },
          {
            type: null,
            is_show: false,
            label: '結束時間',
            grids: [
              {
                id: 'end_at',
                label: '結束時間',
                value: null,
                hint: '日期',
                type: 'date',
                is_show: false,
              },
              {
                id: 'end_at_time',
                label: '',
                value: null,
                type: 'time',
                is_show: false,
                hint: '時間',
              },
            ],
          },
        ],
        submit_text: '更新',
        submit_callback: 'submit',
        close_callback: 'close',
        views: null,
      },
      open_update_experience_url_dialog_setting: {},
      snackbar: false,
      snackColor: '',
      snackText: '',
      is_open_edit_priority_dialog: false,

      // 檢查版本詳情區塊都有設定才可以變成true，然後發布實驗
      is_check: false,
      is_open_update_url_dialog: false,
      is_open_update_url_rule_dialog: false,
      is_open_edit_views_name_dialog: false,
      is_open_edit_views_memo_dialog: false,
      selected_view_id: null,
      experiment_setting: {
        is_show: false,
        data: null,
      },
      mapping_backend_field: {
        開始時間: 'start_at',
        結束時間: 'end_at',
        活動開始時間: 'campaign_start_at',
        活動結束時間: 'campaign_end_at',
      },
      protocol: '',
      hostname: '',
      pathname: '',
      search: '',
      hash: '',
      check_rule_dialog_setting: {
        title: '檢查網頁規則',
        fields: [
          {
            id: 'url',
            label: '網址',
            hint: '例如: https://www.example.com/test/?test=true#test',
            type: 'text',
            value: null,
          },
        ],
        views: null,
        headers: null,
        submit_text: '檢查',
        submit_callback: 'submit',
        close_callback: 'close',
      },
      rules: this.$utils.field_rules,
      check_url: '',
      text_setting: {
        title: '更新實驗',
        submit_text: '更新',
        cancel_text: '取消',
      },
      save_load_dialog: false,
      experience_devices: [
        {
          text: '桌機',
          value: 'pc',
        },
        {
          text: '平板',
          value: 'pad',
        },
        {
          text: '手機',
          value: 'phone',
        },
      ],
      activate_devices: [],
      remove_hash_tag: false,
      table_key: 1,
      view_schedule_list: [],
      curr_view_schedule_item: {},
      view_schedule_headers: [
        { text: '版本名稱', value: 'name', sortable: false },
        { text: '權重(%)', value: 'priority', sortable: false },
      ],
      create_view_schedule_dialog: false,
      delete_view_schedule_dialog: false,
      notify_dialog: {
        is_show: false,
        vid: '',
        items: [],
        loading: false,
        loading_text: '載入中',
        no_data_text: '沒有記錄',
        headers: [
          { text: '通知', value: 'push_status', sortable: false },
          { text: '發生時間', value: 'created_at', sortable: false },
          { text: '已處理時間', value: 'read_at', sortable: false },
          { text: '網址', value: 'url', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ],
        tab: null,
      },
      check_same_rule_url_data: {
        dialog: false,
        list: [],
        total_page: 1,
        page: 1,
      },
    }
  },
  created: async function () {
    try {
      // 載入loading 圖示
      this.isLoading = true

      // 取得版本資料
      await this.reGetExpData()

      if (this.experiment.device) {
        let activate_devices = this.experiment.device.split(',')
        activate_devices.forEach((activate_device) => {
          let idx = this.experience_devices.findIndex((experience_device) => {
            return experience_device.value === activate_device
          })
          this.activate_devices.push(idx)
        })
      }

      if (this.experiment.add_column) {
        let add_column = JSON.parse(this.experiment.add_column)
        if (add_column['remove_hash_tag'] !== null && add_column['remove_hash_tag'] !== undefined) {
          this.remove_hash_tag = add_column['remove_hash_tag']
        }
      }

      // 取得設定的規則
      await this.getExperienceRule()

      // 好像是網址規則的說明
      this.prepareUrlDescription()

      // 結束時間小於現在的話，自動跳報表tab
      if (!this.$route.query.tab) {
        if (this.experiment.release === true) {
          this.tab = 'report'
        }
      } else {
        let is_exist = this.tab_items.findIndex((item) => {
          return item.key === this.$route.query.tab
        })
        if (is_exist !== -1) {
          this.tab = this.$route.query.tab
        } else {
          this.tab = 'report'
        }
      }
    } catch (e) {
      console.log(e)
      this.$root.vtoast.show({
        message: e,
        color: 'error',
      })
    } finally {
      this.isLoading = false
    }

    await this.getViewSchedule()
    this.initCurrViewScheduleItem()
  },
  methods: {
    toPage(url) {
      window.open(url)
    },
    async copy(url) {
      await navigator.clipboard.writeText(url)
      this.$root.vtoast.show({ message: '已複製', color: 'primary' })
    },
    async getSameRuleUrlList() {
      try {
        const res = await apiGetSameRuleUrlList(this.$route.params.org_id, this.experiment.id)
        if (res) {
          this.check_same_rule_url_data.list = res
          this.check_same_rule_url_data.total_page = Math.ceil(res.length / 10)
        }
      } catch (error) {
        console.error('getSameRuleUrlList() :', error)
        this.$root.vtoast.show({ message: '取得資料失敗', color: 'error' })
      }
    },
    async checkSameRuleUrlSwitch(status) {
      if (!status) {
        return (this.check_same_rule_url_data.dialog = false)
      }

      await this.getSameRuleUrlList()
      this.check_same_rule_url_data.dialog = true
    },
    handleCheckUrl(url) {
      this.check_url = decodeURIComponent(url)
    },
    async getReportResult() {
      let result
      result = await apiGetAnalysisReport(this.$route.params.org_id, this.experiment.id)
        .then((resp) => {
          let msg
          if (resp['data']['ok'] === 1) {
            const {
              data: { data, msg: message },
            } = resp
            msg = message
            return data
          } else {
            this.$root.vtoast.show({ message: msg, color: 'error' })
            return null
          }
        })
        .catch((error) => {
          console.log(error)
          this.$root.vtoast.show({ message: '取得分析結果錯誤，原因: ' + error.response ? error.response : error })
          return null
        })
      return result
    },
    removeChip(idx) {
      this.check_rule_chip_items.splice(idx, 1)
      this.rule_items = this.rule_items.map((item) => {
        let newItem = { ...item }
        delete newItem.is_match
        return newItem
      })
    },
    checkUrlIsMatchRulePattern(url_val) {
      this.rule_items = this.rule_items.map((item) => {
        // 如果item.pattern是不符合、不等於、不什麼什麼的要反轉結果
        return { ...item, is_match: this.checkUrlIsMatchRulePattern2(item.regex, item.mode, item.pattern, url_val) }
      })
      this.is_show_check_rule_dialog = false
    },
    restitutionAboutCheckRule() {
      setTimeout(() => {
        this.rule_items = this.rule_items.map((item) => {
          let newItem = { ...item }
          delete newItem.is_match
          return newItem
        })
      }, 3000)
    },
    checkUrlIsMatchRulePattern2(regex, mode, pattern, url_val) {
      let url = new URL(decodeURIComponent(decodeURIComponent(url_val)))
      let result
      switch (mode) {
        case 'url':
          if (pattern === 'mc' || pattern === 'nmc') {
            result =
              pattern.charAt(0) === 'n'
                ? !this.$utils.validateByRegex(regex, url.origin + url.pathname)
                : this.$utils.validateByRegex(regex, url.origin + url.pathname)
            return result
          }
          result =
            pattern.charAt(0) === 'n'
              ? !this.$utils.validateByRegex(regex, url.href)
              : this.$utils.validateByRegex(regex, url.href)
          break

        case 'host':
          result =
            pattern.charAt(0) === 'n'
              ? !this.$utils.validateByRegex(regex, url.hostname)
              : this.$utils.validateByRegex(regex, url.hostname)
          break

        case 'path':
          result =
            pattern.charAt(0) === 'n'
              ? !this.$utils.validateByRegex(regex, url.pathname)
              : this.$utils.validateByRegex(regex, url.pathname)
          break

        case 'urlFragment':
          result =
            pattern.charAt(0) === 'n'
              ? !this.$utils.validateByRegex(regex, url.hash.replace('#', ''))
              : this.$utils.validateByRegex(regex, url.hash.replace('#', ''))
          break

        default:
          break
      }
      return result
    },
    prepareUrlDescription() {
      let url = new URL('https://www.example.com/test/?test=true#test')
      this.protocol = url.protocol
      this.hostname = url.hostname
      this.pathname = url.pathname
      this.search = url.search
      this.hash = url.hash.replace('#', '')
    },
    async updateView(fields) {
      let params = {
        view: {
          id: this.selected_view_id,
          experience_id: this.experiment.id,
        },
      }

      fields.forEach((field) => {
        params['view'][field.id] = field.value
      })

      // 發布後只能 rename
      if (this.experiment.release) {
        try {
          params = {
            name: params.view.name,
            memo: params.view.memo,
          }
          await apiRenameVersion(this.$route.params.org_id, this.selected_view_id, params)
          this.close_edit_views_dialog()
        } catch (error) {
          this.$root.vtoast.show({
            message: '更新版本名稱失敗，原因: ' + error,
          })
        }
        return
      }

      apiPatchView(params, this.$route.params.org_id)
        .then(async (resp) => {
          if (resp.data.ok === 1) {
            this.$root.vtoast.show({
              message: '更新版本資訊成功！',
              color: 'primary',
            })
            this.close_edit_views_dialog()
          }
        })
        .catch((error) => {
          console.log(error)
          this.$root.vtoast.show({
            message: '更新版本資訊失敗，原因: ' + error,
          })
        })
    },
    check_is_already() {
      // 決定發布實驗按鈕能不能按最重要的function
      // 檢查每個部分都有才可以開始發布實驗
      if (this.items.length === 0) return (this.is_check = false)
      if (this.rule_items.length === 0) return (this.is_check = false)

      // 這個先關，正式上線要記得開，檢查有沒有安裝opt99代碼
      if (!this.selectedContainer.is_installed) return (this.is_check = false)

      if ((this.experiment.enable && this.experiment.release) || (!this.experiment.enable && this.experiment.release))
        return (this.is_check = false)

      this.is_check = true
    },
    deleteExperienceRule(item) {
      const confirm_dialog = confirm(`請問您確定要刪除此條件嗎？`)
      if (confirm_dialog) {
        apiDeleteExperienceRule(item.id, this.$route.params.org_id)
          .then((resp) => {
            if (resp.data.ok === 1) {
              this.$root.vtoast.show({ message: '刪除條件成功!', color: 'primary' })
              this.getExperienceRule()
              this.check_is_already()
            }
          })
          .catch((error) => {
            console.log(error)
            this.$root.vtoast.show({
              message: '刪除網頁條件錯誤，原因: ' + error.response ? error.response : error,
            })
          })
      } else {
        console.log('不刪除')
      }
    },
    updateExperienceRule(fields) {
      if (fields[1]['newValue'] === null) {
        this.$root.vtoast.show({
          message: '儲存失敗，尚未輸入值～',
          color: 'error',
        })
        return
      }
      let param = {
        rule_id: this.rule_id,
      }
      fields.forEach((field) => {
        param[field.id] = field.value
        if (field.id === 'pattern') {
          param[field.id] = this.mapping_rule[field.value]
        }
        if (field.id === 'values') {
          if (field.newValue !== null) {
            field.value.push(field.newValue)
          }
          param[field.id] = field.value
        }
        if (field.id === 'mode') {
          param[field.id] = this.mapping_rule[field.value]
        }
      })

      console.log('param', param)

      if (param.values.length <= 0) {
        apiDeleteExperienceRule(param.rule_id, this.$route.params.org_id)
          .then((resp) => {
            if (resp.data.ok === 1) {
              this.$root.vtoast.show({
                message: '更新條件成功!',
                color: 'primary',
              })
              this.close()
              this.getExperienceRule()
              this.check_is_already()
            }
          })
          .catch((error) => {
            console.log(error)
            this.$root.vtoast.show({
              message: '更新條件失敗，原因: ' + error.response ? error.response : error,
            })
          })
      } else {
        apiUpdateExperienceRule(this.$route.params.org_id, param)
          .then(() => {
            this.$root.vtoast.show({ message: '更新網頁規則成功!', color: 'primary' })
            this.close()
          })
          .catch((error) => {
            console.log(error)
            this.$root.vtoast.show({
              message: '更新規則失敗，原因: ' + error.response ? error.response : error,
            })
          })
      }
    },
    createExperienceRule(fields) {
      let param = {
        mode: null,
        experience_id: this.experiment.id,
        values: [],
        pattern: '',
      }
      fields.forEach((field) => {
        if (field.id === 'pattern') {
          param[field.id] = this.mapping_rule[field.value]
        }
        if (field.id === 'values') {
          param[field.id].push(field.value)
        }
        if (field.id === 'mode') {
          param[field.id] = this.mapping_rule[field.value]
        }
      })

      apiCreateExperienceRule(this.$route.params.org_id, param)
        .then(() => {
          this.$root.vtoast.show({ message: '新增網址規則成功!', color: 'primary' })
          this.getExperienceRule()
          this.check_is_already()
          this.close()
        })
        .catch((error) => {
          console.log(error)
          this.$root.vtoast.show({
            message: '新增網頁規則失敗，原因: ' + error,
          })
        })
    },
    async getExperienceRule() {
      await apiGetExperienceRule(this.experiment.id, this.$route.params.org_id)
        .then(async (resp) => {
          this.rule_items = await resp.data.data
          while (this.check_rule_chip_items.length) {
            this.check_rule_chip_items.pop()
          }
          await this.check_is_already()
        })
        .catch((error) => {
          console.log(error)
          this.$root.vtoast.show({
            message: '取得網頁規則錯誤，原因: ' + error,
          })
        })
    },
    open_target_object_dialog() {
      this.is_open_target_object_dialog = true
    },
    open_url_rule_dialog() {
      this.url_rule_dialog_setting.fields = this.url_rule_dialog_setting.fields.map((item) => {
        if (item.id === 'values') {
          item.value = null
        }
        if (item.id === 'pattern') {
          item.value = null
        }
        item.value = null
        return item
      })

      // 給定預設新增規則彈窗預設值
      this.url_rule_dialog_setting.fields[0]['value'] = '完整網址'
      this.url_rule_dialog_setting.fields[1]['value'] = '包含'

      this.is_open_url_rule_dialog = true
    },
    async open_update_url_rule_dialog(update_item) {
      this.rule_id = update_item.id
      this.update_url_rule_dialog_setting.fields = await this.update_url_rule_dialog_setting.fields.map((item) => {
        if (item.id === 'values') {
          item.value = update_item.value
          item.newValue = null
        }
        if (item.id === 'pattern') {
          item.value = this.reverse_mapping_rule[update_item.pattern]
        }
        if (item.id === 'mode') {
          item.value = this.reverse_mapping_rule[update_item.mode]
        }
        return item
      })
      this.is_open_update_url_rule_dialog = await true
    },
    close_url_rule_dialog() {
      this.is_open_url_rule_dialog = false
    },
    async copyToClipboard(item, value) {
      // value這個變數的值是從InstallAbTestScriptDialog.vue這個子元件傳來的
      try {
        let textToCopy
        switch (item) {
          case 'head_script':
            if (value !== undefined) {
              textToCopy = value
            } else {
              textToCopy = await this.$refs.head_script.value
            }

            break

          case 'body_script':
            if (value !== undefined) {
              textToCopy = value
            } else {
              textToCopy = await this.$refs.body_script.value
            }

            break

          case 'token':
            textToCopy = await this.$refs.token.value
            break
          case 'line_bot':
            textToCopy = await this.$refs.line_bot.value
            break
          default:
            textToCopy = '未知'
            break
        }
        await navigator.clipboard.writeText(textToCopy)
        this.snackbar = await true
      } catch (err) {
        console.error('無法複製: ', err)
      }
    },
    async releaseExperience() {
      // 等缺貨提醒功能完善再開啟吧
      // if (this.experiment.platform === null && this.experiment.url.includes('https://www.wonder.tw')) {
      //   this.$root.vtoast.show({ message: "偵測到您尚未開啟缺貨提醒，請您先開啟缺貨提醒再發布實驗。", color: 'warning' })
      //   return
      // }

      let confirm_dialog = confirm(
        `請問您確定要將 ${this.experiment.name} 這個實驗發布嗎?   請注意發布後無法再更改此實驗！`
      )

      if (confirm_dialog) {
        this.save_load_dialog = true
        await apiPatchExperienceRelease(this.experiment.id, this.$route.params.org_id)
          .then((resp) => {
            this.save_load_dialog = false
            let { data } = resp
            if (data['code'] === 200) {
              this.$root.vtoast.show({ message: '發布實驗成功!', color: 'primary' })
              setTimeout(() => {
                this.$router.go()
              }, 500)
            } else {
              this.save_load_dialog = false
              this.$root.vtoast.show({
                message: '發布實驗失敗，原因: ' + data.msg,
              })
            }
          })
          .catch((error) => {
            console.log('發布失敗', error)
            this.$root.vtoast.show({
              message: '發布實驗失敗，原因: ' + error.response ? error.response.data : error,
            })
          })
      } else {
        console.log('不發布')
      }
    },
    close_script_dialog() {
      this.isOpenAbtestScript = false
    },
    open_script_dialog() {
      this.isOpenAbtestScript = true
    },
    async close_edit_priority_dialog() {
      this.is_open_edit_priority_dialog = false
      this.dialog_setting.views = null
      this.reGetExpData()
    },
    async open_dialog() {
      delete this.dialog_setting['fields'][0]['value']
      this.dialog_setting['views'] = null
      this.dialog_setting['headers'] = null
      this.dialog_setting['submit_callback'] = 'submit'
      this.dialog_setting['close_callback'] = 'close'
      this.dialog_setting['title'] = '新增變化版本'
      this.dialog_setting['submit_text'] = '新增'
      this.is_show_new_dialog = true
    },
    async open_edit_priority_dialog() {
      this.dialog_setting['views'] = this.items
      this.dialog_setting['title'] = '編輯版本權重'
      this.dialog_setting['headers'] = [
        { text: '版本名稱', value: 'name', sortable: false },
        { text: '權重(%)', value: 'priority', sortable: true },
      ]
      this.dialog_setting['submit_callback'] = 'apiPatchViewPriority'
      this.dialog_setting['close_callback'] = 'close_edit_priority_dialog'
      this.dialog_setting['submit_text'] = '更新權重'
      this.is_open_edit_priority_dialog = true
    },
    async open_edit_views_name_dialog(item) {
      if (item.name === 'original') {
        return
      }
      this.selected_view_id = item.id
      this.dialog_setting['views'] = this.items
      this.dialog_setting['title'] = '編輯變化版本資訊'
      this.dialog_setting['views'] = null
      this.dialog_setting['headers'] = null
      this.dialog_setting['fields'][0] = {
        id: 'name',
        label: '編輯變化版本名稱',
        hint: '例如: 改內文圖',
        type: 'text',
        value: item.name,
      }
      this.dialog_setting['submit_text'] = '完成'
      this.dialog_setting['submit_callback'] = 'submit'
      this.dialog_setting['close_callback'] = 'close'
      this.is_open_edit_views_name_dialog = true
    },
    async open_edit_views_memo_dialog(item) {
      this.selected_view_id = item.id
      this.dialog_setting['views'] = this.items
      this.dialog_setting['title'] = '編輯變化版本說明'
      this.dialog_setting['views'] = null
      this.dialog_setting['headers'] = null
      this.dialog_setting['fields'][0] = {
        id: 'memo',
        label: '編輯變化版本說明',
        hint: '例如: 改內文圖',
        type: 'text',
        value: item.memo,
      }
      this.dialog_setting['submit_text'] = '完成'
      this.dialog_setting['submit_callback'] = 'submit'
      this.dialog_setting['close_callback'] = 'close'
      this.is_open_edit_views_memo_dialog = true
    },
    async close_edit_views_dialog() {
      this.is_open_edit_views_name_dialog = false
      this.is_open_edit_views_memo_dialog = false
      this.dialog_setting['title'] = '新增變化版本'
      this.dialog_setting['submit_text'] = '新增'
      await this.reGetExpData()
    },
    async getView(id) {
      await apiGetView(id, this.$route.params.org_id)
        .then((resp) => console.log(resp))
        .catch((error) => console.log(error))
    },
    getViews: async function (id, org_id) {
      let data = {}
      let that = this
      data = await apiGetExperience(id, org_id)
        .then(function (resp) {
          if (resp.data.data === null) {
            that.$router.push('/container/' + this.$route.params.container_id + '/experiments')
          }
          let data = resp.data.data
          data.views = data.views.sort((a, b) => a.id - b.id)
          data.views = data.views.sort((a, b) => b.is_original - a.is_original)
          return data
        })
        .catch(function (error) {
          console.error('取得版本失敗: ' + error)
          that.$root.vtoast.show({
            message: '取得版本失敗，原因: ' + error.response ? error.response : error,
          })
          return {}
        })
      return data
    },
    submit: async function (fields) {
      let param = {}
      fields.forEach(function (field) {
        param[field.id] = field.value
      })
      param['experience_id'] = this.experiment.id

      let data = await this.createView(param)
      if (data.length === 0) {
        this.close()
        return
      }

      // 照id大小排一下，越大代表越新
      data = data.sort((a, b) => a.id - b.id)
      let calculate_data = this.parse_priority_to_rate(data)
      this.items = calculate_data

      // 問要不要直接編輯
      let confirm_dialog = confirm(`新增成功，確定要立刻編輯這個版本嗎？`)
      if (confirm_dialog) {
        this.viewInfo(this.items[this.items.length - 1])
      }

      this.is_show_new_dialog = false
    },
    async check_have_original(data, param) {
      let result
      let original_views = data.filter((item) => item.name === '原版')
      if (original_views.length === 0) {
        param.name = '原版'
        result = await this.createView(param)
        if (result.length === 0) return
        return result
      } else {
        result = []
        return result
      }
    },
    async createView(param) {
      let data
      data = await apiCreateView(param, this.$route.params.org_id)
        .then((resp) => {
          if (resp.data.ok === 1) {
            this.$root.vtoast.show({
              message: '新增版本成功',
              color: 'primary',
            })
            return resp.data.data
          }

          if (resp.data.msg === 'View limit has been reached') {
            this.$root.vtoast.show({
              message: '新增版本失敗，原因: 已達版本上限，請升級方案或是刪除已經存在的版本',
            })
            return []
          }
        })
        .catch((error) => {
          console.log(error)
          this.$root.vtoast.show({
            message: '新增版本失敗，原因: ' + error.response ? error.response.data : error,
          })
          return []
        })
      return data
    },
    close() {
      this.is_show_new_dialog = false
      this.is_open_url_rule_dialog = false
      this.is_open_target_object_dialog = false
      this.is_open_update_dialog = false
      this.is_open_update_url_dialog = false
      this.is_open_update_url_rule_dialog = false
      this.is_show_check_rule_dialog = false
      this.getExperienceRule()
    },
    async preview(item, return_url, specific_url) {
      let that = this
      let view_id = item.vid
      let token = await apiGetPreviewToken(this.$route.params.org_id, view_id)
        .then(function (resp) {
          let data = resp.data.data.token
          return data
        })
        .catch(function (error) {
          that.$root.vtoast.show({
            message: '取得預覽連結失敗，原因: ' + (error.response ? error.response.data : error),
          })
          return null
        })
      let tmp_url = this.experiment.url
      if (specific_url) {
        tmp_url = specific_url
      }
      let url = new URL(decodeURIComponent(tmp_url))
      url.searchParams.append('opt99_auth_token', token)
      url.searchParams.append('opt99_preview', view_id)

      let organize = this.organize_container_mapper[this.$route.params.org_id]
      let current_container = organize.containers.find((container) => {
        return container.id === this.$route.params.container_id
      })

      let connect_id = current_container.cyberbiz_info
        ? current_container.cyberbiz_info.cb_shop_id.toString()
        : this.$route.params.container_id

      url.searchParams.append('opt99_c_id', connect_id)
      if (return_url) {
        return url.href
      } else {
        window.open(url.href, '_blank').focus()
      }
    },
    viewInfo: function (item) {
      this.$router.push(
        `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/page_editor?experience_id=${this.experiment.id}&view_id=${item.id}&device_type=desktop`
      )
    },
    async deleteVersion(item) {
      let confirm_dialog = confirm(`確定要刪除 ${item.name} 這個版本嗎？`)
      if (confirm_dialog) {
        // is_check true的話是檢查有沒有東西可以刪 false是直接刪除
        let is_check = false
        await apiDeleteView(item.id, is_check, this.$route.params.org_id)
          .then(async () => {
            await this.reGetExpData()
            this.check_is_already()
          })
          .catch((error) => {
            console.log(error)
            if (error.response.status === 401) {
              this.$root.vtoast.show({ message: `您沒有權限刪除版本！` })
            } else {
              this.$root.vtoast.show({ message: '刪除版本失敗，原因: ' + error.response ? error.response.data : error })
            }
          })
      } else {
        console.log('不刪除')
      }
    },
    async apiPatchViewPriorityAverage(views) {
      let params = {}
      let priority = this.calculate_priority(views.length)
      params['experience_id'] = this.experiment.id
      params['priorities'] = []
      views.forEach((view) => {
        params['priorities'].push({
          id: view['id'],
          priority: Number(priority),
        })
      })
      let data = []

      data = await apiPatchViewPriority(params, this.$route.params.org_id)
        .then((resp) => {
          return resp
        })
        .catch((error) => {
          console.log(error)
        })

      return data
    },
    async apiPatchViewPriority(views) {
      let params = {}
      params['experience_id'] = this.experiment.id
      params['priorities'] = []
      views.forEach((view) => {
        params['priorities'].push({
          id: view['id'],
          priority: Number(view['priority']),
        })
      })
      let data = []

      data = await apiPatchViewPriority(params, this.$route.params.org_id)
        .then((resp) => {
          this.is_open_edit_priority_dialog = false
          this.dialog_setting.views = null
          this.$root.vtoast.show({ message: '更新權重成功', color: 'primary' })
          return resp
        })
        .catch((error) => {
          console.log(error)
          if (error.includes('401')) {
            this.$root.vtoast.show({ message: `您沒有權限更新權重。` })
            this.close_edit_priority_dialog()
          } else if (error.includes('must at least business')) {
            this.$root.vtoast.show({ message: '您的方案不支援更新權重，請升級到business方案。' })
          } else {
            this.$root.vtoast.show({
              message: error,
            })
          }
        })

      return data
    },
    /***
     * @function calculate_priority
     * @description
     * @param {number} views_length
     * @returns {string|number}
     */
    calculate_priority(views_length) {
      return Math.trunc((1 / Number(views_length)) * 100) / 100
    },
    /**
     * @function parse_priority_to_rate
     * @description 將陣列中的每一個物件的 priority 屬性乘上 100，並將其轉換成百分比形式。
     * @param {Array} arr - 陣列物件。
     * @return {Array} - 回傳陣列物件，其中的 priority 屬性已被轉換成百分比形式。
     */
    parse_priority_to_rate(Arr) {
      let data = Arr.reduce((acc, cur) => {
        return [...acc, { ...cur, priority: `${cur.priority * 100}`.split('.')[0] }]
      }, [])

      return data
    },
    async updateExperience(item) {
      let params = {
        target_type: 'abtest', //先寫死，目前也只有這一個type
      }

      item.forEach((field) => {
        params[field.id] = field.value
        if (field.grids !== undefined && field.grids.length === 2) {
          let time_end = ':00'
          if (field.grids[0].id.includes('end_at')) {
            time_end = ':59'
          }
          params[this.mapping_backend_field[field.label]] =
            field.grids[0]['value'] + ' ' + field.grids[1]['value'] + time_end
        }
      })
      params['campaign_start_at'] = params['start_at']
      params['campaign_end_at'] = params['end_at']

      await apiPatchExperiment(this.experiment.id, this.$route.params.org_id, params)
        .then(async (resp) => {
          let { data } = resp
          this.close()
          if (data.code === 200) {
            this.$root.vtoast.show({
              message: '更新實驗成功！',
              color: 'primary',
            })
            delete params.target_type
            Object.hasOwn(params, 'url') ? (params.url = decodeURIComponent(decodeURIComponent(params.url))) : params
            let data = await this.getViews(this.$route.params.experiment_id, this.$route.params.org_id)
            this.experiment = data
            this.items = this.parse_priority_to_rate(data.views)
          } else {
            this.$root.vtoast.show({
              message: '更新實驗失敗，原因: ' + resp.data.msg !== '' ? resp.data.msg : '更新實驗失敗!',
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.$root.vtoast.show({ message: '更新實驗失敗，原因: ' + error.response ? error.response : error })
        })
    },
    async updateExperienceV2(setting) {
      let params = {
        target_type: 'abtest',
        name: setting.name,
        memo: setting.memo ? setting.memo : '',
        start_at: `${setting.start_at}:00`,
        end_at: `${setting.end_at}:59`,
        url: setting.url,
      }
      params['campaign_start_at'] = params.start_at
      params['campaign_end_at'] = params.end_at

      try {
        // release後只能改名字
        if (setting.release) {
          params = {
            name: setting.name,
            end_at: `${setting.end_at}:59`,
          }
        }
        await apiPatchExperimentWithData(this.experiment.id, this.$route.params.org_id, params)

        delete params.target_type
        Object.hasOwn(params, 'url') ? (params.url = decodeURIComponent(decodeURIComponent(params.url))) : params
        await this.reGetExpData()
        this.$root.vtoast.show({ message: '更新實驗成功！', color: 'primary' })
      } catch (error) {
        console.log(error)
        this.$root.vtoast.show({ message: `更新實驗失敗，原因: ${error}` })
      }
      this.close()
    },
    openUpdateExperientsDialog() {
      this.open_update_experience_dialog_setting['fields'] = this.open_update_experience_dialog_setting['fields'].map(
        (field) => {
          if (field.grids !== undefined) {
            field.grids = field.grids.map((grid) => {
              let value = ''
              if (grid.type === 'date') {
                value = this.experiment[grid.id].split(' ')[0]
              } else {
                let id_key = grid.id.replace('_time', '')
                value = this.experiment[id_key].split(' ')[1]
                let values = value.split(':')
                value = values[0] + ':' + values[1]
              }
              // 如果id裡有time的話，是我自己建的，所以this.experiment[grid.id] === undefined找不到，這時就拿grids第0項的id去Vuex裡面查找拿值塞進去
              return {
                ...grid,
                value: value,
              }
            })
          } else if (this.experiment[field.id] !== undefined) {
            // 除了時間以外的值(input的type是text)，應該都會走這邊
            return { ...field, value: this.experiment[field.id] }
          }
          return field
        }
      )

      this.is_open_update_dialog = true
    },
    open_update_url_dialog() {
      this.open_update_experience_url_dialog_setting = JSON.parse(
        JSON.stringify(this.open_update_experience_dialog_setting)
      )
      this.open_update_experience_url_dialog_setting['fields'] = this.open_update_experience_dialog_setting['fields']
        .filter((item) => {
          return item.id === 'url'
        })
        .map((field) => {
          return { ...field, value: this.experiment[field.id], label: '編輯器頁面' }
        })

      this.open_update_experience_url_dialog_setting['title'] = '修改編輯器頁面'
      this.is_open_update_url_dialog = true
    },
    updateUrlRuleDialogSetting() {
      this.close()
      this.open_url_rule_dialog()
    },
    openCheckWebRuleDialog() {
      this.check_rule_dialog_setting['fields'][0]['value'] = null
      this.is_show_check_rule_dialog = true
    },
    checkWebRule() {
      this.checkUrlIsMatchRulePattern(decodeURIComponent(this.check_url))
      while (this.check_rule_chip_items.length) {
        this.check_rule_chip_items.pop()
      }
      this.check_rule_chip_items.push(this.check_url)
      this.check_url = ''
    },
    async stopExperiment() {
      let id = this.$route.params.experiment_id
      let confirm_dialog = confirm(`請問您確定結束實驗嗎? 結束後無法再更改此實驗！`)
      if (!confirm_dialog) {
        return
      }
      await apiPatchExperienceDisable(id, this.$route.params.org_id)
        .then(() => {
          this.$root.vtoast.show({ message: '結束實驗成功!', color: 'primary' })
          this.$router.go()
        })
        .catch((error) => {
          console.log('結束實驗失敗', error)
          this.$root.vtoast.show({
            message: '結束實驗失敗，原因: ' + (error.response ? JSON.stringify(error.response.data) : error),
          })
        })
    },
    async updateDevice(activate_devices) {
      if (activate_devices.length <= 0) {
        this.$root.vtoast.show({ message: '至少選擇一個裝置。', color: 'error' })
        return
      }

      try {
        let devices = activate_devices.map((activate_device) => {
          return this.experience_devices[activate_device].value
        })

        let params = {
          device: devices.join(','),
        }
        await apiPatchExperimentWithData(this.$route.params.experiment_id, this.$route.params.org_id, params)
      } catch (error) {
        console.log('u_error', error)
        this.$root.vtoast.show({ message: `更新失敗，原因:${error}` })
      }
    },
    async updateReplaceHashTag(remove_hash_tag) {
      let add_column = this.experiment.add_column
      if (!add_column) {
        add_column = {}
      } else {
        add_column = JSON.parse(add_column)
      }

      add_column['remove_hash_tag'] = remove_hash_tag
      delete add_column['replace_hash_tag']
      try {
        let params = {
          add_column: JSON.stringify(add_column),
        }
        await apiPatchExperimentWithData(this.$route.params.experiment_id, this.$route.params.org_id, params)
        this.experiment.add_column = JSON.stringify(add_column)
      } catch (error) {
        console.log('hash_tag_error', error)
        this.$root.vtoast.show({ message: `更新失敗，原因:${error}` })
      }
    },
    async copyVer(item) {
      try {
        let params = {
          vid: item.vid,
        }
        await apiCopyVersion(this.$route.params.org_id, params)
        this.reGetExpData()
      } catch (error) {
        console.log('copy_error', error)
        if (error.includes('already copied')) {
          // 取得複製的版本
          let copy_views = await apiGetCopyView(this.$route.params.org_id, this.$route.params.experiment_id)

          let target = copy_views.find((copy_view) => {
            return copy_view.copy_from === item.vid
          })

          target = this.experiment.views.find((view) => {
            return view.vid === target.copy_to
          })

          this.$root.vtoast.show({ message: `這個版本已經被 ${target.name} 修改了，請編輯此版本或是刪除再重新修改。` })
        } else {
          this.$root.vtoast.show({ message: `修改失敗，原因: ${error}` })
        }
      }
    },
    async reGetExpData() {
      this.view_loading = true
      this.items = []

      let data = await this.getViews(this.$route.params.experiment_id, this.$route.params.org_id)

      this.experiment = data
      this.experiment_setting = data
      this.experiment_setting.is_show = true
      let parse_result = this.parse_priority_to_rate(this.experiment.views)
      let view_unread_notice = this.experiment.view_unread_notice
      this.items = parse_result
      this.items = this.items.sort((a, b) => a.id - b.id)
      this.items = this.items.sort((a, b) => b.is_original - a.is_original)
      this.view_loading = false
      // 取得複製的版本
      let copy_views = await apiGetCopyView(this.$route.params.org_id, this.$route.params.experiment_id)

      copy_views = copy_views.sort((a, b) => a.id - b.id)
      copy_views.forEach((copy_view) => {
        let from_target = this.items.findIndex((view) => {
          return view.vid === copy_view.copy_from
        })

        let to_target = this.items.findIndex((view) => {
          return view.vid === copy_view.copy_to
        })
        if (from_target !== -1) {
          if (copy_view.release_by) {
            this.items[from_target].is_copy_release = true
          } else {
            this.items[from_target].is_copy_release = false
          }
          if (!this.items[from_target].history) {
            this.items[from_target].history = []
          }
          this.items[from_target].history.push(copy_view)
        }

        if (to_target !== -1) {
          if (!this.items[to_target].history) {
            this.items[to_target].history = []
          }
          this.items[to_target].history.push(copy_view)
        }
      })

      for (let idx = 0; idx < copy_views.length; idx++) {
        let parent_view_idx = this.items.findIndex((item) => {
          return item.vid === copy_views[idx].copy_from
        })

        let to_idx = this.items.findIndex((item) => {
          return item.vid === copy_views[idx].copy_to
        })

        let tmp = JSON.parse(JSON.stringify(this.items[to_idx]))
        this.items.splice(to_idx, 1)
        this.items.splice(parent_view_idx + 1, 0, tmp)
      }

      this.items.forEach((item, idx) => {
        item['sort_key'] = idx

        if (this.experiment.released_view && this.experiment.released_view[item.vid]) {
          item['is_can_edit'] = false
        } else {
          item['is_can_edit'] = true
        }

        if (view_unread_notice && view_unread_notice[item.vid]) {
          item.notify = view_unread_notice[item.vid].dynamicViewError
        } else {
          item.notify = 'no_notice'
        }
      })
      console.log('view_unread_notice', view_unread_notice)

      this.table_key += 1

      // 強迫顯示要取代的麵包屑
      this.$store.commit('update_breadcrumbs', [
        {
          text: '頁面優化',
          disabled: true,
        },
        {
          text: '實驗',
          disabled: false,
          href: `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/experiments/`,
        },
        {
          text: `${this.experiment.name}`,
          disabled: false,
          icon: 'mdi-pencil',
          callback: this.openUpdateExperientsDialog,
        },
      ])
    },
    async releaseView(item) {
      try {
        let params = {
          vid: item.vid,
        }
        await apiReleaseVersion(this.$route.params.org_id, params)
      } catch (error) {
        console.log('release_error', error)
      }

      this.reGetExpData()
    },
    async showHistory(item) {
      let items = []
      let user_info = {}
      let user_ids = []
      for (let idx = 0; idx < item.history.length; idx++) {
        if (!user_ids.includes(item.history[idx].creator)) {
          user_ids.push(item.history[idx].creator)
        }

        if (!user_ids.includes(item.history[idx].release_by) && item.history[idx].release_by) {
          user_ids.push(item.history[idx].release_by)
        }
      }

      try {
        let params = {
          user_id: user_ids,
        }
        let result = await apiGetUserInfo(this.$route.params.org_id, params)
        result.forEach(function (tmp) {
          user_info[tmp.id] = tmp.user_name
        })
      } catch (error) {
        console.log('get_info_error', error)
      }

      item.history = item.history.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime())
      item.history = item.history.reverse()
      item.history.forEach((history) => {
        if (history.copy_from === item.vid) {
          if (history.release_by) {
            items.push({
              name: user_info[history.release_by],
              action: '停止',
              time: this.$utils.getYYYYMMDDHHMMSS(history.release_at, '-'),
            })
          }

          items.push({
            name: user_info[history.creator],
            action: '被複製',
            time: this.$utils.getYYYYMMDDHHMMSS(history.created_at, '-'),
          })
        }

        if (history.copy_to === item.vid) {
          if (history.release_by) {
            items.push({
              name: user_info[history.release_by],
              action: '發布',
              time: this.$utils.getYYYYMMDDHHMMSS(history.release_at, '-'),
            })
          }

          items.push({
            name: user_info[history.creator],
            action: '建立',
            time: this.$utils.getYYYYMMDDHHMMSS(history.created_at, '-'),
          })
        }
      })

      this.history_items = items
      this.is_open_history = true
    },
    async getViewSchedule() {
      try {
        const res = (await apiGetViewSchedule(this.$route.params.org_id, this.experiment.id)).filter(
          (item) => item.status !== 2
        )
        res.forEach((item) => {
          item.memo ? (item.memo = JSON.parse(item.memo)) : (item.memo = {})
          item.expand_switch = false // 內容顯示開關
          item.edit_description_switch = false
        })
        this.view_schedule_list = res
      } catch (error) {
        this.$root.vtoast.show({ message: '取得權重排程資料失敗' })
      }
    },
    async updateViewSchedule(item) {
      try {
        const now = Date.now()
        const start_time = (new Date(item.start_at) * 1000) / 1000
        if (start_time <= now) {
          return this.$root.vtoast.show({ message: '該排程已啟動，若在進行中請至上方修改' })
        }

        let total_priority = 0
        for (const key in item.setting) {
          total_priority += Number(item.setting[key])
        }

        if (total_priority !== 1) {
          return this.$root.vtoast.show({ message: '權重總和必須為1' })
        }
        const params = {
          creator: item.creator,
          experience_id: this.experiment.id,
          id: item.id,
          start_at: item.start_at,
          memo: JSON.stringify(item.memo),
          setting: item.setting,
        }

        await apiUpdateViewSchedule(this.$route.params.org_id, params)
        this.$root.vtoast.show({ message: '更新排程成功' })
        await this.getViewSchedule()
        item.backup_original = JSON.parse(JSON.stringify(item))
      } catch (error) {
        console.log('UPDATE VIEW SCHEDULE ERROR :', error)
        this.$root.vtoast.show({ message: '更新排程失敗' })
      }
    },
    async createViewSchedule() {
      try {
        // new block
        if (!this.curr_view_schedule_item.start_at) {
          return this.$root.vtoast.show({ message: '開始時間不得為空' })
        }
        if (new Date(this.curr_view_schedule_item.start_at) <= new Date()) {
          return this.$root.vtoast.show({ message: '開始時間不得早於當前時間' })
        }
        if (!this.checkCreateViewScheduleTime(this.curr_view_schedule_item.start_at)) {
          return this.$root.vtoast.show({
            message: '此建立時間與原有的恢復時間排程時段重疊，請重新輸入建立時間或刪除原有的恢復時間排程',
          })
        }

        if (this.curr_view_schedule_item.description?.length > 10) {
          return this.$root.vtoast.show({ message: '說明不得超過10個字' })
        }

        let total_priority = 0
        for (const key in this.curr_view_schedule_item.setting) {
          total_priority += Number(this.curr_view_schedule_item.setting[key]) * 100
        }
        if (total_priority !== 100) {
          return this.$root.vtoast.show({ message: '權重總和必須為1' })
        }

        const params = {
          experience_id: this.experiment.id,
          start_at: this.curr_view_schedule_item.start_at,
          memo: JSON.stringify({ description: this.curr_view_schedule_item.description }),
          setting: this.curr_view_schedule_item.setting,
        }

        await apiCreateViewSchedule(this.$route.params.org_id, params)

        // recovery block
        if (this.curr_view_schedule_item.recover_at) {
          if (new Date(this.curr_view_schedule_item.recover_at) <= new Date(this.curr_view_schedule_item.start_at)) {
            return this.$root.vtoast.show({ message: '恢復到當前設定時間不得小於開始時間' })
          }

          if (!this.checkCreateViewScheduleTime(this.curr_view_schedule_item.recover_at)) {
            return this.$root.vtoast.show({
              message: '此恢復時間與其他恢復時間排程時段重疊，請重新輸入恢復時間或刪除原有的恢復時間排程',
            })
          }

          const recovery_params = {
            experience_id: this.experiment.id,
            start_at: this.curr_view_schedule_item.recover_at,
            memo: JSON.stringify({ description: '恢復到當前設定', is_recovery: true }),
            setting: {},
          }
          this.experiment.views.forEach((item) => {
            recovery_params.setting[item.vid] = item.priority
          })

          await apiCreateViewSchedule(this.$route.params.org_id, recovery_params)
        }

        this.viewScheduleDialogSwitch('create_view_schedule_dialog')
        this.$root.vtoast.show({ message: '新增排程成功' })
        this.getViewSchedule()
      } catch (error) {
        console.log('CREATE VIEW SCHEDULE ERROR :', error)
        this.$root.vtoast.show({ message: '新增排程失敗' })
      }
    },
    async deleteViewSchedule() {
      try {
        await apiDeleteViewSchedule(this.$route.params.org_id, this.curr_view_schedule_item.id)
        this.$root.vtoast.show({ message: '刪除排程成功' })
        this.getViewSchedule()
      } catch (error) {
        console.log('DELETE VIEW SCHEDULE ERROR :', error)
        this.$root.vtoast.show({ message: '刪除排程失敗' })
      } finally {
        this.viewScheduleDialogSwitch('delete_view_schedule_dialog')
      }
    },
    changeDataFormatToTable(item) {
      const data = []
      for (const key in item) {
        if (this.view_schedule_version_name[key] === '原始版本') {
          data.unshift({ name: key, priority: item[key] * 100 })
        } else {
          data.push({ name: key, priority: item[key] * 100 })
        }
      }
      return data
    },
    descriptionEditDialogSwitch(item, index) {
      item.edit_description_switch = true
      item.curr_description = item.memo.description || ''
      this.$nextTick(() => {
        document.getElementById(`edit_description_${index}`).focus()
      })
    },
    viewScheduleItemExpandSwitch(item, type = 'default') {
      const types = {
        open: true,
        close: false,
        default: !item.expand_switch,
      }
      item.expand_switch = types[type]
      if (item.expand_switch) {
        item.backup_original = JSON.parse(JSON.stringify(item))
      } else {
        this.resetUpdateViewScheduleItem(item)
      }
    },
    // 復原權重排程未保存的修改
    resetUpdateViewScheduleItem(item) {
      item.memo.description = item.backup_original.memo.description || ''
      item.setting = JSON.parse(JSON.stringify(item.backup_original.setting))
    },
    // 處理編輯權重排程說明欄位的失焦事件
    editDescriptionBlur(e, item, index) {
      const target = e.relatedTarget
      const contains = document.getElementById(`edit_description_${index}`).contains(target)
      if (!contains) {
        item.edit_description_switch = false
        item.curr_description = ''
      }
    },
    saveCurrPriorityValue(item, edit_item) {
      edit_item.priority = edit_item.curr_priority
      item.setting[edit_item.name] = edit_item.priority * 0.01
    },
    saveCurrDescriptionValue(item) {
      if (this.inputRules().textLength(item.curr_description) !== true) {
        return
      }
      item.memo.description = item.curr_description
      item.edit_description_switch = false
    },
    checkCreateViewScheduleTime(time) {
      const create_time = new Date(time)
      const stop_index = this.view_schedule_list.length - 1
      for (const [index, item] of this.view_schedule_list.entries()) {
        if (item.memo.is_recovery) {
          if (index === stop_index) {
            return create_time > new Date(item.start_at)
          } else if (
            new Date(this.view_schedule_list[index + 1].start_at) <= create_time &&
            create_time <= new Date(item.start_at)
          ) {
            return false
          }
        }
      }
      return true
    },
    initCurrViewScheduleItem() {
      this.curr_view_schedule_item = { setting: {} }
      for (const key in this.view_schedule_version_name) {
        Object.assign(this.curr_view_schedule_item.setting, { [key]: 0 })
      }
    },
    viewScheduleDialogSwitch(type, item) {
      if (item) {
        this.curr_view_schedule_item = item
      }
      // 關閉 Dialog 都要清空暫存資料
      if (this[type]) {
        this.initCurrViewScheduleItem()
      }

      this[type] = !this[type]
    },
    viewScheduleStatusStyle(item_index) {
      let now = new Date().getTime()
      if (now < new Date(this.view_schedule_list[item_index].start_at).getTime()) {
        return { status: '未啟用', color: this.$vuetify.theme.themes.light.draft }
      }

      if (this.applying_version_index > item_index) {
        return { status: '未啟用', color: this.$vuetify.theme.themes.light.draft }
      } else if (this.applying_version_index < item_index) {
        return { status: '已結束', color: this.$vuetify.theme.themes.light.end }
      } else {
        return { status: '啟用中', color: this.$vuetify.theme.themes.light.release }
      }
    },
    // TODO: 之後需要共用再做
    inputRules() {
      const textLength = (v) => {
        if (v) {
          return v.length <= 10 || '最多輸入 10 個字'
        }
        return true
      }
      return {
        textLength,
      }
    },
    async showNotifys(vid, type) {
      console.log('type', type)
      this.notify_dialog.vid = vid
      this.notify_dialog.tab = type
      console.log('notify_dialog', this.notify_dialog)
      this.notify_dialog = JSON.parse(JSON.stringify(this.notify_dialog))
      this.notify_dialog.is_show = true
      this.notify_dialog.loading = true
      type = type === 'read' ? 1 : 0
      let tmp_headers = this.notify_dialog.headers.filter((header) => {
        if (type === 1) {
          return header
        } else {
          return header.value !== 'read_at'
        }
      })
      this.notify_dialog.show_headers = tmp_headers
      let clarity_prefix = ''
      let clarity_url = ''
      try {
        let result = await apiGetContainer(this.$route.params.org_id, this.$route.params.container_id)
        console.log('result', result)
        let add_column = result.data.add_column
        if (add_column) {
          add_column = JSON.parse(add_column)
        }
        console.log('add_column', add_column)
        if (add_column.else && add_column.else.else) {
          if (add_column.else.else.clarity_prefix && add_column.else.else.clarity_prefix.value) {
            clarity_prefix = add_column.else.else.clarity_prefix.value
          }
        }
      } catch (error) {
        console.log('get-container-data-error', error)
      }
      console.log('prefix', clarity_prefix)
      try {
        if (clarity_prefix) {
          clarity_prefix = clarity_prefix.replace(/\/$/, '')
          clarity_url = `${clarity_prefix}/impressions`
        }
      } catch (error) {
        console.log('clarity_prefix-error', error)
      }

      try {
        let result = await apiGetContainerNotify(
          this.$route.params.org_id,
          this.$route.params.container_id,
          vid,
          type,
          1,
          10000,
          'dynamicViewError'
        )
        this.notify_dialog.items = result.data.content.map((item) => {
          let timestamp = new Date(item.created_at).getTime()
          let created_at = this.$utils.getYYYYMMDDHHMMSS(item.created_at, '-')
          let read_at = item.read_at ? this.$utils.getYYYYMMDDHHMMSS(item.read_at, '-') : ''

          if (clarity_url && item.metadata.event_uuid) {
            let date = created_at.split(' ')[0]
            let start_at = new Date(`${date} 00:00:00`).getTime()
            let end_at = new Date(`${date} 23:59:00`).getTime()
            clarity_url = new URL(clarity_url)
            clarity_url.searchParams.append('CustomUserId', `is;${item.metadata.event_uuid}`)
            clarity_url.searchParams.append('date', `Custom`)
            clarity_url.searchParams.append('end', end_at)
            clarity_url.searchParams.append('start', start_at)
            clarity_url = clarity_url.href
          }

          return {
            timestamp: timestamp,
            created_at: created_at,
            url: item.metadata.trigger_url ? item.metadata.trigger_url : item.metadata.url,
            read_at: read_at,
            push_status: item.push_status,
            clarity_url: clarity_url,
            id: item.id,
          }
        })

        this.notify_dialog.items.sort((a, b) => b.timestamp - a.timestamp)

        console.log('notifys-result', result)
        console.log('notifys-items', this.notify_dialog.items)
      } catch (error) {
        console.log('notify-error', error)
      }
      this.notify_dialog.loading = false
    },
    async readNotify(item) {
      console.log('item', item)

      let is_read = confirm('確定是否標記為已處理?')
      if (!is_read) {
        return
      }
      try {
        let result = await apiReadNotify(this.$route.params.org_id, item.id)
        console.log('read-result', result)
      } catch (error) {
        console.log('read-error', error)
      }

      this.showNotifys(this.notify_dialog.vid, this.notify_dialog.tab)
      this.reGetExpData()
      this.$root.vnotify()
    },
    async goView(url, vid) {
      let preview_url = new URL(url)
      preview_url.searchParams.append('specific_view', vid)
      this.$utils.openURL(preview_url.href, '')
    },
    copyURL(url, vid) {
      let preview_url = new URL(url)
      preview_url.searchParams.append('specific_view', vid)
      this.$utils.copyText(preview_url.href)
      this.$root.vtoast.show({
        message: '網址已經複製到剪貼簿了！',
      })
    },
    getRowClass(item) {
      let vid = this.$route.query.vid
      // console.log('getRowClass', item)
      if (item.vid === vid) {
        return 'highlight-yellow'
      }
      return ''
    },
  },
  computed: {
    ...mapGetters(['memberQuota', 'selectedContainer', 'loggedInfo', 'organize_container_mapper']),
    is_draft() {
      return this.is_check ? '草稿。  已準備完成。  請點擊右側按鈕開始您的實驗。' : '草稿。 您有幾個設定步驟尚未完成。'
    },
    is_release() {
      return this.experiment.enable && this.experiment.release ? '發布中。 無法對實驗進行更新。 僅供檢視。' : ''
    },
    is_end() {
      return !this.experiment.enable && this.experiment.release ? '實驗已結束。 無法對實驗進行更新。 僅供檢視。' : ''
    },
    is_inactivate() {
      const result = this.memberQuota[this.$route.params.org_id].quotaVo.find((item) =>
        item['function'].includes('AbTesting')
      )
      let is_inactivate = false
      if (this.items.length >= result['limit']) {
        is_inactivate = true
      }

      return is_inactivate
    },
    is_already() {
      return (this.experiment.enable && this.experiment.release) || (!this.experiment.enable && this.experiment.release)
    },
    isEditableStep1() {
      return this.items.length !== 0 ? false : true
    },
    isCompleteStep1() {
      return this.items.length !== 0 ? true : false
    },
    isEditableStep2() {
      return this.rule_items.length !== 0 ? false : true
    },
    isCompleteStep2() {
      return this.rule_items.length !== 0 ? true : false
    },
    isEditableStep3() {
      return this.selectedContainer.is_installed ? false : true
    },
    isCompleteStep3() {
      return this.selectedContainer.is_installed ? true : false
    },
    isEditableStep4() {
      return this.is_check ? false : true
    },
    isCompleteStep4() {
      return this.is_check ? true : false
    },
    mdi_icon() {
      if (this.experiment.enable && this.experiment.release) {
        return 'mdi-publish'
      } else if (this.experiment.enable === false && this.experiment.release) {
        return 'mdi-progress-close'
      } else {
        return this.is_check ? 'mdi-file-document-edit-outline' : 'mdi-alert-circle-outline'
      }
    },
    checkInputValueIsValidate() {
      return !this.$utils.validateUrl(this.check_url)
    },
    getQuota() {
      const result = this.memberQuota[this.$route.params.org_id].quotaVo.find((item) =>
        item['function'].includes('AbTesting')
      )
      return result['limit']
    },
    view_schedule_version_name() {
      return this.experiment.views.reduce((arr, curr) => {
        arr[curr.vid] = curr.name === 'original' ? '原始版本' : curr.name
        return arr
      }, {})
    },
    applying_version_index() {
      for (const index in this.view_schedule_list) {
        const item_time = new Date(this.view_schedule_list[index].start_at)
        if (item_time < Date.now()) {
          return Number(index)
        }
      }
    },
    // 發布狀態確定版本
    isDraft() {
      return !this.experiment.release && this.experiment.enable
    },
    isRelease() {
      return (
        this.experiment.release === true &&
        this.experiment.enable === true &&
        new Date().getTime() < new Date(this.experiment.end_at).getTime()
      )
    },
    isEnd() {
      return !(!this.experiment.release && this.experiment.enable) && Date.now() > new Date(this.experiment.end_at)
    },
    show_same_rule_url_list() {
      return this.check_same_rule_url_data.list.slice(
        (this.check_same_rule_url_data.page - 1) * 10,
        this.check_same_rule_url_data.page * 10
      )
    },
  },
  watch: {
    rule_items: {
      handler: function (newValue) {
        this.rule_items = newValue
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
.truncate-url {
  margin: 0;
  padding: 0;
  max-width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style lang="scss">
.version-list-page {
  h4 {
    color: #5b5b5b;
  }

  .btn-danger {
    background: #e3262e;
    background-image: linear-gradient(180deg, #e3262e, #ab171e);
    color: #fff;
    border: 1px solid #ab171e;
    text-decoration: none;
    min-width: 40px;
    box-shadow: inset 0 1px 1px #ff7b81, 0 2px 2px -1px rgba(0, 0, 0, 0.2);
  }

  .priority_btn:hover {
    background-color: rgb(70, 143, 238);
  }

  .truncate {
    display: block !important;
    margin-left: auto;
    box-sizing: border-box;
  }

  .v-breadcrumbs__item--disabled {
    color: rgba(0, 0, 0, 0.38) !important;
  }

  div#truncate {
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block !important;
    margin-left: auto;
    box-sizing: border-box;
  }

  .version_name {
    white-space: nowrap;
    width: 200px;
    max-width: 250px;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .item-clickable {
    cursor: pointer;
  }

  .memo-field {
    white-space: nowrap;
    max-width: 250px;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }

  //.experiment_status.running {
  //  background: #1c73e8;
  //  color: #fff;
  //}
  //
  //.experiment_status.end {
  //  background: #33a853;
  //  color: #fff;
  //}

  //.experiment_time.running {
  //  background-color: #165abc;
  //}
  //
  //.experiment_time.end {
  //  background-color: #137333;
  //}

  .edit-description-card {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }
}

.v-small-dialog__content .v-text-field__details {
  display: none;
}
</style>
<style>
.chip-style {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  line-height: 32px;
}
.highlight-yellow td {
  background-color: bisque;
}
</style>
